/**
 * @fileoverview MessageConst const<br>
 * 本ファイルは定義書より出力されるため直接編集禁止<br>
 * 変更がある場合は定義書を変更しファイルを生成してください。
 */
'use strict';
const MessageConst = {
  COMMON: {
    /**
     * LogiPull - ロジプル -
     * @name ID001
     * @constant
     * @memberOf const.MessageConst
     */
    ID001: 'LogiPull - ロジプル -',

    /**
     * マイページ
     * @name ID002
     * @constant
     * @memberOf const.MessageConst
     */
    ID002: 'マイページ',

    /**
     * ログアウト
     * @name ID003
     * @constant
     * @memberOf const.MessageConst
     */
    ID003: 'ログアウト',

    /**
     * ホーム
     * @name ID101
     * @constant
     * @memberOf const.MessageConst
     */
    ID101: 'ホーム',

    /**
     * 予約・受付管理<br>
     * 日本トランスシティ カスタマイズ
     * @name ID102
     * @constant
     * @memberOf const.MessageConst
     */
    ID102: '予約・受付管理',

    /**
     * 予約状況
     * @name ID103
     * @constant
     * @memberOf const.MessageConst
     */
    ID103: '予約状況',

    /**
     * 予約・受付一覧<br>
     * 日本トランスシティ カスタマイズ
     * @name ID104
     * @constant
     * @memberOf const.MessageConst
     */
    ID104: '予約・受付一覧',

    /**
     * 予約割当
     * @name ID105
     * @constant
     * @memberOf const.MessageConst
     */
    ID105: '予約割当',

    /**
     * 車両管理
     * @name ID106
     * @constant
     * @memberOf const.MessageConst
     */
    ID106: '車両管理',

    /**
     * ドライバー管理
     * @name ID107
     * @constant
     * @memberOf const.MessageConst
     */
    ID107: 'ドライバー管理',

    /**
     * 配送会社管理
     * @name ID108
     * @constant
     * @memberOf const.MessageConst
     */
    ID108: '配送会社管理',

    /**
     * ユーザー管理
     * @name ID109
     * @constant
     * @memberOf const.MessageConst
     */
    ID109: 'ユーザー管理',

    /**
     * システム設定
     * @name ID110
     * @constant
     * @memberOf const.MessageConst
     */
    ID110: 'システム設定',

    /**
     * バース設定
     * @name ID111
     * @constant
     * @memberOf const.MessageConst
     */
    ID111: 'バース設定',

    /**
     * お知らせ管理
     * @name ID112
     * @constant
     * @memberOf const.MessageConst
     */
    ID112: 'お知らせ管理',

    /**
     * 受付一覧<br>
     * 受付機能
     * @name ID113
     * @constant
     * @memberOf const.MessageConst
     */
    ID113: '受付一覧',

    /**
     * 混雑状況<br>
     * 受付機能
     * @name ID114
     * @constant
     * @memberOf const.MessageConst
     */
    ID114: '混雑状況',

    /**
     * 混雑状況一覧<br>
     * 受付機能
     * @name ID115
     * @constant
     * @memberOf const.MessageConst
     */
    ID115: '混雑状況一覧',

    /**
     * 受付管理<br>
     * 受付機能
     * @name ID116
     * @constant
     * @memberOf const.MessageConst
     */
    ID116: '受付管理',

    /**
     * 実績管理<br>
     * 受付/実績機能
     * @name ID117
     * @constant
     * @memberOf const.MessageConst
     */
    ID117: '実績管理',

    /**
     * ユーザー一覧
     * @name ID118
     * @constant
     * @memberOf const.MessageConst
     */
    ID118: 'ユーザー一覧',

    /**
     * 配送会社一覧
     * @name ID119
     * @constant
     * @memberOf const.MessageConst
     */
    ID119: '配送会社一覧',

    /**
     * 満空情報<br>
     * 実績機能
     * @name ID120
     * @constant
     * @memberOf const.MessageConst
     */
    ID120: '満空情報',

    /**
     * マスタ設定<br>
     * 日本トランスシティ カスタマイズ
     * @name ID121
     * @constant
     * @memberOf const.MessageConst
     */
    ID121: 'マスタ設定',

    /**
     * © 2023 Computer Engineering & Consulting, Ltd.<br>
     * コピーライト
     * @name ID201
     * @constant
     * @memberOf const.MessageConst
     */
    ID201: '© 2023 Computer Engineering & Consulting, Ltd.',

    /**
     * OK
     * @name ID301
     * @constant
     * @memberOf const.MessageConst
     */
    ID301: 'OK',

    /**
     * キャンセル
     * @name ID302
     * @constant
     * @memberOf const.MessageConst
     */
    ID302: 'キャンセル',

    /**
     * ja<br>
     * ローカライズ文字列
     * @name ID401
     * @constant
     * @memberOf const.MessageConst
     */
    ID401: 'ja',

    /**
     * YYYY/MM/DD HH:mm<br>
     * moment.js 年月日時分
     * @name ID402
     * @constant
     * @memberOf const.MessageConst
     */
    ID402: 'YYYY/MM/DD HH:mm',

    /**
     * YYYY/MM/DD<br>
     * moment.js 年月日
     * @name ID403
     * @constant
     * @memberOf const.MessageConst
     */
    ID403: 'YYYY/MM/DD',

    /**
     * mm月<br>
     * moment.js 月
     * @name ID404
     * @constant
     * @memberOf const.MessageConst
     */
    ID404: 'mm月',

    /**
     * yyyy<br>
     * moment.js 年
     * @name ID405
     * @constant
     * @memberOf const.MessageConst
     */
    ID405: 'yyyy',

    /**
     * HH:mm<br>
     * moment.js 時分
     * @name ID406
     * @constant
     * @memberOf const.MessageConst
     */
    ID406: 'HH:mm',

    /**
     * YYYY年MM月DD日(ddd)<br>
     * mobiscroll dataFormat
     * @name ID407
     * @constant
     * @memberOf const.MessageConst
     */
    ID407: 'YYYY年MM月DD日(ddd)',

    /**
     * YYYY/MM<br>
     * moment.js 年月
     * @name ID408
     * @constant
     * @memberOf const.MessageConst
     */
    ID408: 'YYYY/MM',

    /**
     * H:mm<br>
     * moment.js 時分
     * @name ID409
     * @constant
     * @memberOf const.MessageConst
     */
    ID409: 'H:mm',

    /**
     * YYYY/MM/DD(ddd)<br>
     * moment.js 年月日曜日
     * @name ID410
     * @constant
     * @memberOf const.MessageConst
     */
    ID410: 'YYYY/MM/DD(ddd)',

    /**
     * YYYY年MM月DD日<br>
     * moment.js 年月日
     * @name ID411
     * @constant
     * @memberOf const.MessageConst
     */
    ID411: 'YYYY年MM月DD日',

    /**
     * yy/mm/dd<br>
     * mobiscroll 年月日
     * @name ID412
     * @constant
     * @memberOf const.MessageConst
     */
    ID412: 'yy/mm/dd',

    /**
     * YYYY/MM/DD(ddd) HH:mm<br>
     * moment.js 年月日曜日時分
     * @name ID413
     * @constant
     * @memberOf const.MessageConst
     */
    ID413: 'YYYY/MM/DD(ddd) HH:mm',

    /**
     * MM/DD<br>
     * moment.js 月日
     * @name ID414
     * @constant
     * @memberOf const.MessageConst
     */
    ID414: 'MM/DD',

    /**
     * yy年mm月dd日(D)<br>
     * moment.js 年月日曜日
     * @name ID415
     * @constant
     * @memberOf const.MessageConst
     */
    ID415: 'yy年mm月dd日(D)',

    /**
     * ：
     * @name ID501
     * @constant
     * @memberOf const.MessageConst
     */
    ID501: '：',

    /**
     * -
     * @name ID502
     * @constant
     * @memberOf const.MessageConst
     */
    ID502: '-',

    /**
     * ～
     * @name ID503
     * @constant
     * @memberOf const.MessageConst
     */
    ID503: '～',

    /**
     * ×
     * @name ID504
     * @constant
     * @memberOf const.MessageConst
     */
    ID504: '×',

    /**
     * T
     * @name ID505
     * @constant
     * @memberOf const.MessageConst
     */
    ID505: 'T',

    /**
     * 分
     * @name ID506
     * @constant
     * @memberOf const.MessageConst
     */
    ID506: '分',

    /**
     * 休
     * @name ID507
     * @constant
     * @memberOf const.MessageConst
     */
    ID507: '休',

    /**
     * 必須
     * @name ID508
     * @constant
     * @memberOf const.MessageConst
     */
    ID508: '必須',

    /**
     * 月
     * @name ID509
     * @constant
     * @memberOf const.MessageConst
     */
    ID509: '月',

    /**
     * 火
     * @name ID510
     * @constant
     * @memberOf const.MessageConst
     */
    ID510: '火',

    /**
     * 水
     * @name ID511
     * @constant
     * @memberOf const.MessageConst
     */
    ID511: '水',

    /**
     * 木
     * @name ID512
     * @constant
     * @memberOf const.MessageConst
     */
    ID512: '木',

    /**
     * 金
     * @name ID513
     * @constant
     * @memberOf const.MessageConst
     */
    ID513: '金',

    /**
     * 土
     * @name ID514
     * @constant
     * @memberOf const.MessageConst
     */
    ID514: '土',

    /**
     * 日
     * @name ID515
     * @constant
     * @memberOf const.MessageConst
     */
    ID515: '日',

    /**
     * ・
     * @name ID516
     * @constant
     * @memberOf const.MessageConst
     */
    ID516: '・',

    /**
     * 検索結果件数
     * @name ID517
     * @constant
     * @memberOf const.MessageConst
     */
    ID517: '検索結果件数',

    /**
     * @
     * @name ID518
     * @constant
     * @memberOf const.MessageConst
     */
    ID518: '@',

    /**
     * ログイン画面に戻る
     * @name ID519
     * @constant
     * @memberOf const.MessageConst
     */
    ID519: 'ログイン画面に戻る',

    /**
     * ※
     * @name ID520
     * @constant
     * @memberOf const.MessageConst
     */
    ID520: '※',

    /**
     * 「-」は入力しないでください。
     * @name ID521
     * @constant
     * @memberOf const.MessageConst
     */
    ID521: '「-」は入力しないでください。',

    /**
     * バース種別
     * @name ID522
     * @constant
     * @memberOf const.MessageConst
     */
    ID522: 'バース種別',

    /**
     * （
     * @name ID523
     * @constant
     * @memberOf const.MessageConst
     */
    ID523: '（',

    /**
     * ）
     * @name ID524
     * @constant
     * @memberOf const.MessageConst
     */
    ID524: '）',

    /**
     * ○
     * @name ID525
     * @constant
     * @memberOf const.MessageConst
     */
    ID525: '○',

    /**
     * 条件を指定して検索<br>
     * スマホ対応
     * @name ID526
     * @constant
     * @memberOf const.MessageConst
     */
    ID526: '条件を指定して検索',

    /**
     * 削除対象にする<br>
     * スマホ対応
     * @name ID527
     * @constant
     * @memberOf const.MessageConst
     */
    ID527: '削除対象にする',

    /**
     * メールアドレス
     * @name ID601
     * @constant
     * @memberOf const.MessageConst
     */
    ID601: 'メールアドレス',

    /**
     * パスワード
     * @name ID602
     * @constant
     * @memberOf const.MessageConst
     */
    ID602: 'パスワード',

    /**
     * xxxxx@xxx.co.jp
     * @name ID603
     * @constant
     * @memberOf const.MessageConst
     */
    ID603: 'xxxxx@xxx.co.jp',

    /**
     * 50文字まで
     * @name ID604
     * @constant
     * @memberOf const.MessageConst
     */
    ID604: '50文字まで',

    /**
     * 半角英数字8~32文字
     * @name ID605
     * @constant
     * @memberOf const.MessageConst
     */
    ID605: '半角英数字8~32文字',

    /**
     * 全角1~4桁
     * @name ID606
     * @constant
     * @memberOf const.MessageConst
     */
    ID606: '全角1~4桁',

    /**
     * 半角数字1~3桁
     * @name ID607
     * @constant
     * @memberOf const.MessageConst
     */
    ID607: '半角数字1~3桁',

    /**
     * ひらがな1文字
     * @name ID608
     * @constant
     * @memberOf const.MessageConst
     */
    ID608: 'ひらがな1文字',

    /**
     * 半角数字1~4桁
     * @name ID609
     * @constant
     * @memberOf const.MessageConst
     */
    ID609: '半角数字1~4桁',

    /**
     * 09012345678
     * @name ID610
     * @constant
     * @memberOf const.MessageConst
     */
    ID610: '09012345678',

    /**
     * 一連番号を入力
     * @name ID611
     * @constant
     * @memberOf const.MessageConst
     */
    ID611: '一連番号を入力',

    /**
     * 2<br>
     * 利用バース数
     * @name ID612
     * @constant
     * @memberOf const.MessageConst
     */
    ID612: '2',

    /**
     * 120<br>
     * 作業時間
     * @name ID613
     * @constant
     * @memberOf const.MessageConst
     */
    ID613: '120',

    /**
     * 128文字まで
     * @name ID614
     * @constant
     * @memberOf const.MessageConst
     */
    ID614: '128文字まで',

    /**
     * 4000文字まで
     * @name ID615
     * @constant
     * @memberOf const.MessageConst
     */
    ID615: '4000文字まで',

    /**
     * 1~99まで
     * @name ID616
     * @constant
     * @memberOf const.MessageConst
     */
    ID616: '1~99まで',

    /**
     * 半角英数字記号8~32文字
     * @name ID617
     * @constant
     * @memberOf const.MessageConst
     */
    ID617: '半角英数字記号8~32文字',

    /**
     * ひらがな50文字まで
     * @name ID618
     * @constant
     * @memberOf const.MessageConst
     */
    ID618: 'ひらがな50文字まで',

    /**
     * 半角数字・半角英字(大文字のみ) 1～3桁
     * @name ID619
     * @constant
     * @memberOf const.MessageConst
     */
    ID619: '半角数字・半角英字(大文字のみ) 1～3桁',

    /**
     * 半角英数字(小文字のみ)・半角記号(ハイフン・アンダースコアのみ)3～20桁<br>
     * 企業コード（DoCoMap連携）
     * @name ID620
     * @constant
     * @memberOf const.MessageConst
     */
    ID620:
      '半角英数字(小文字のみ)・半角記号(ハイフン・アンダースコアのみ)3～20桁',

    /**
     * 半角英数字(小文字のみ)・半角記号(ハイフン・アンダースコアのみ)1~7桁<br>
     * 端末コード（DoCoMap連携）
     * @name ID621
     * @constant
     * @memberOf const.MessageConst
     */
    ID621:
      '半角英数字(小文字のみ)・半角記号(ハイフン・アンダースコアのみ)1~7桁',

    /**
     * 通信が混雑しています。しばらくたってから、再度実行してください。
     * @name ID701
     * @constant
     * @memberOf const.MessageConst
     */
    ID701: '通信が混雑しています。しばらくたってから、再度実行してください。',

    /**
     * を入力してください。
     * @name ID702
     * @constant
     * @memberOf const.MessageConst
     */
    ID702: 'を入力してください。',

    /**
     * が不正です。
     * @name ID703
     * @constant
     * @memberOf const.MessageConst
     */
    ID703: 'が不正です。',

    /**
     * は半角英数字で入力してください。
     * @name ID704
     * @constant
     * @memberOf const.MessageConst
     */
    ID704: 'は半角英数字で入力してください。',

    /**
     * 該当ページが存在しません。先頭ページを表示します。
     * @name ID705
     * @constant
     * @memberOf const.MessageConst
     */
    ID705: '該当ページが存在しません。先頭ページを表示します。',

    /**
     * は50桁以内で入力してください。
     * @name ID706
     * @constant
     * @memberOf const.MessageConst
     */
    ID706: 'は50桁以内で入力してください。',

    /**
     * は半角数字のみで入力してください。
     * @name ID707
     * @constant
     * @memberOf const.MessageConst
     */
    ID707: 'は半角数字のみで入力してください。',

    /**
     * 行目
     * @name ID708
     * @constant
     * @memberOf const.MessageConst
     */
    ID708: '行目',

    /**
     * ファイルを選択してください。
     * @name ID709
     * @constant
     * @memberOf const.MessageConst
     */
    ID709: 'ファイルを選択してください。',

    /**
     * ファイルのアップロードに失敗しました。
     * @name ID710
     * @constant
     * @memberOf const.MessageConst
     */
    ID710: 'ファイルのアップロードに失敗しました。',

    /**
     * しばらくたってからやり直してください。
     * @name ID711
     * @constant
     * @memberOf const.MessageConst
     */
    ID711: 'しばらくたってからやり直してください。',

    /**
     * CSVファイルを選択してください。
     * @name ID712
     * @constant
     * @memberOf const.MessageConst
     */
    ID712: 'CSVファイルを選択してください。',

    /**
     * の取得に失敗しました。
     * @name ID713
     * @constant
     * @memberOf const.MessageConst
     */
    ID713: 'の取得に失敗しました。',

    /**
     * 曜日の
     * @name ID714
     * @constant
     * @memberOf const.MessageConst
     */
    ID714: '曜日の',

    /**
     * は
     * @name ID715
     * @constant
     * @memberOf const.MessageConst
     */
    ID715: 'は',

    /**
     * より後の時間を入力してください。
     * @name ID716
     * @constant
     * @memberOf const.MessageConst
     */
    ID716: 'より後の時間を入力してください。',

    /**
     * 取得に失敗しました。
     * @name ID718
     * @constant
     * @memberOf const.MessageConst
     */
    ID718: '取得に失敗しました。',

    /**
     * 指定いただいたログインIDはご使用になれません。
     * @name ID719
     * @constant
     * @memberOf const.MessageConst
     */
    ID719: '指定いただいたログインIDはご使用になれません。',

    /**
     * を選択してください。
     * @name ID720
     * @constant
     * @memberOf const.MessageConst
     */
    ID720: 'を選択してください。',

    /**
     * 255文字まで
     * @name ID721
     * @constant
     * @memberOf const.MessageConst
     */
    ID721: '255文字まで',

    /**
     * 現在のパスワードが間違っています。
     * @name ID722
     * @constant
     * @memberOf const.MessageConst
     */
    ID722: '現在のパスワードが間違っています。',

    /**
     * 新しいパスワード(確認用)の入力が、新しいパスワードの入力と異なります。
     * @name ID723
     * @constant
     * @memberOf const.MessageConst
     */
    ID723:
      '新しいパスワード(確認用)の入力が、新しいパスワードの入力と異なります。',

    /**
     * 予約可能期間の開始日は、終了日より大きい数字を入力してください。
     * @name ID724
     * @constant
     * @memberOf const.MessageConst
     */
    ID724: '予約可能期間の開始日は、終了日より大きい数字を入力してください。',

    /**
     * は8文字以上32文字以内で入力してください。
     * @name ID725
     * @constant
     * @memberOf const.MessageConst
     */
    ID725: 'は8文字以上32文字以内で入力してください。',

    /**
     * 指定したバース種別の予約情報が見つかりません。
     * @name ID726
     * @constant
     * @memberOf const.MessageConst
     */
    ID726: '指定したバース種別の予約情報が見つかりません。',

    /**
     * 割当可能なバースが存在しません。
     * @name ID727
     * @constant
     * @memberOf const.MessageConst
     */
    ID727: '割当可能なバースが存在しません。',

    /**
     * ダウンロードに失敗しました。
     * @name ID728
     * @constant
     * @memberOf const.MessageConst
     */
    ID728: 'ダウンロードに失敗しました。',

    /**
     * 割り当て情報を変更してから、確定ボタンを押してください。
     * @name ID729
     * @constant
     * @memberOf const.MessageConst
     */
    ID729: '割り当て情報を変更してから、確定ボタンを押してください。',

    /**
     * 変更した予約情報がすべて元の状態に戻ります。
     * @name ID730
     * @constant
     * @memberOf const.MessageConst
     */
    ID730: '変更した予約情報がすべて元の状態に戻ります。',

    /**
     * バース種別を変更しますか？
     * @name ID731
     * @constant
     * @memberOf const.MessageConst
     */
    ID731: 'バース種別を変更しますか？',

    /**
     * 日付を変更しますか？
     * @name ID732
     * @constant
     * @memberOf const.MessageConst
     */
    ID732: '日付を変更しますか？',

    /**
     * キャンセルしてよろしいですか？
     * @name ID733
     * @constant
     * @memberOf const.MessageConst
     */
    ID733: 'キャンセルしてよろしいですか？',

    /**
     * ファイル名は50文字以内にしてください。
     * @name ID734
     * @constant
     * @memberOf const.MessageConst
     */
    ID734: 'ファイル名は50文字以内にしてください。',

    /**
     * ファイルの合計サイズは5MBまでにしてください。
     * @name ID735
     * @constant
     * @memberOf const.MessageConst
     */
    ID735: 'ファイルの合計サイズは5MBまでにしてください。',

    /**
     * は全角1～4桁で入力してください。
     * @name ID736
     * @constant
     * @memberOf const.MessageConst
     */
    ID736: 'は全角1～4桁で入力してください。',

    /**
     * はひらがな1文字で入力してください。
     * @name ID737
     * @constant
     * @memberOf const.MessageConst
     */
    ID737: 'はひらがな1文字で入力してください。',

    /**
     * 予約状況の取得に失敗しました。一度ログアウトし、再度ログインしてください。
     * @name ID738
     * @constant
     * @memberOf const.MessageConst
     */
    ID738:
      '予約状況の取得に失敗しました。一度ログアウトし、再度ログインしてください。',

    /**
     * データの取得に失敗しました。
     * @name ID739
     * @constant
     * @memberOf const.MessageConst
     */
    ID739: 'データの取得に失敗しました。',

    /**
     * バース情報が変更されたため予約割り当てに失敗しました。
     * @name ID740
     * @constant
     * @memberOf const.MessageConst
     */
    ID740: 'バース情報が変更されたため予約割り当てに失敗しました。',

    /**
     * 割り当て対象の予約が削除されたか、別の予約により割当先が重複しました。情報を再取得し、再度割り当てを行ってください。
     * @name ID741
     * @constant
     * @memberOf const.MessageConst
     */
    ID741:
      '割り当て対象の予約が削除されたか、別の予約により割当先が重複しました。情報を再取得し、再度割り当てを行ってください。',

    /**
     * センター側の設定が変更されました。
     * @name ID742
     * @constant
     * @memberOf const.MessageConst
     */
    ID742: 'センター側の設定が変更されました。',

    /**
     * 予約がいっぱいです。別の日時を選びなおしてください。
     * @name ID743
     * @constant
     * @memberOf const.MessageConst
     */
    ID743: '予約がいっぱいです。別の日時を選びなおしてください。',

    /**
     * 指定された予約情報では予約情報の更新ができません。
     * @name ID744
     * @constant
     * @memberOf const.MessageConst
     */
    ID744: '指定された予約情報では予約情報の更新ができません。',

    /**
     * 指定された予約情報に削除できないものが含まれていたため削除できませんでした。
     * @name ID745
     * @constant
     * @memberOf const.MessageConst
     */
    ID745:
      '指定された予約情報に削除できないものが含まれていたため削除できませんでした。',

    /**
     * バースを削除すると、対象バースに割り当てられている未来の予約がすべて未割り当てとなります。
     * @name ID746
     * @constant
     * @memberOf const.MessageConst
     */
    ID746:
      'バースを削除すると、対象バースに割り当てられている未来の予約がすべて未割り当てとなります。',

    /**
     * 予約者への予約変更メールも送信されます。
     * @name ID747
     * @constant
     * @memberOf const.MessageConst
     */
    ID747: '予約者への予約変更メールも送信されます。',

    /**
     * 実行してよろしいですか？
     * @name ID748
     * @constant
     * @memberOf const.MessageConst
     */
    ID748: '実行してよろしいですか？',

    /**
     * 掲載中のお知らせが含まれています。削除しますか？
     * @name ID749
     * @constant
     * @memberOf const.MessageConst
     */
    ID749: '掲載中のお知らせが含まれています。削除しますか？',

    /**
     * 開始日は終了日より過去の日付を選択してください。
     * @name ID750
     * @constant
     * @memberOf const.MessageConst
     */
    ID750: '開始日は終了日より過去の日付を選択してください。',

    /**
     * 旧パスワードが正しくありません。
     * @name ID751
     * @constant
     * @memberOf const.MessageConst
     */
    ID751: '旧パスワードが正しくありません。',

    /**
     * 入力値が不正です。
     * @name ID752
     * @constant
     * @memberOf const.MessageConst
     */
    ID752: '入力値が不正です。',

    /**
     * を削除しますか？
     * @name ID753
     * @constant
     * @memberOf const.MessageConst
     */
    ID753: 'を削除しますか？',

    /**
     * しますか？
     * @name ID754
     * @constant
     * @memberOf const.MessageConst
     */
    ID754: 'しますか？',

    /**
     * 仮予約を受け付けました。
     * @name ID755
     * @constant
     * @memberOf const.MessageConst
     */
    ID755: '仮予約を受け付けました。',

    /**
     * を正しく入力してください。
     * @name ID756
     * @constant
     * @memberOf const.MessageConst
     */
    ID756: 'を正しく入力してください。',

    /**
     * 指定された名称は既に使用されています。別の名称を指定してください。
     * @name ID757
     * @constant
     * @memberOf const.MessageConst
     */
    ID757: '指定された名称は既に使用されています。別の名称を指定してください。',

    /**
     * 指定された車種名は既に使用されています。別の車種名を指定してください。
     * @name ID758
     * @constant
     * @memberOf const.MessageConst
     */
    ID758:
      '指定された車種名は既に使用されています。別の車種名を指定してください。',

    /**
     * 編集画面に移動しますか？
     * @name ID759
     * @constant
     * @memberOf const.MessageConst
     */
    ID759: '編集画面に移動しますか？',

    /**
     * は1以上を入力してください。
     * @name ID760
     * @constant
     * @memberOf const.MessageConst
     */
    ID760: 'は1以上を入力してください。',

    /**
     * 受付データの取得に失敗しました。
     * @name ID761
     * @constant
     * @memberOf const.MessageConst
     */
    ID761: '受付データの取得に失敗しました。',

    /**
     * エラーコード
     * @name ID762
     * @constant
     * @memberOf const.MessageConst
     */
    ID762: 'エラーコード',

    /**
     * 受付情報の指定IDが無効です。
     * @name ID763
     * @constant
     * @memberOf const.MessageConst
     */
    ID763: '受付情報の指定IDが無効です。 ',

    /**
     * 受付情報を変更する権限がありません。
     * @name ID764
     * @constant
     * @memberOf const.MessageConst
     */
    ID764: '受付情報を変更する権限がありません。',

    /**
     * 受付状態の指定IDが無効です。
     * @name ID765
     * @constant
     * @memberOf const.MessageConst
     */
    ID765: '受付状態の指定IDが無効です。',

    /**
     * 受付状態の更新に失敗しました。
     * @name ID766
     * @constant
     * @memberOf const.MessageConst
     */
    ID766: '受付状態の更新に失敗しました。',

    /**
     * サインを入力してください。
     * @name ID767
     * @constant
     * @memberOf const.MessageConst
     */
    ID767: 'サインを入力してください。',

    /**
     * 受付のキャンセルに成功しました。
     * @name ID768
     * @constant
     * @memberOf const.MessageConst
     */
    ID768: '受付のキャンセルに成功しました。',

    /**
     * 混雑状況の取得に失敗しました。
     * @name ID769
     * @constant
     * @memberOf const.MessageConst
     */
    ID769: '混雑状況の取得に失敗しました。',

    /**
     * バース種別が存在しません。
     * @name ID770
     * @constant
     * @memberOf const.MessageConst
     */
    ID770: 'バース種別が存在しません。',

    /**
     * 実績データの取得に失敗しました。
     * @name ID771
     * @constant
     * @memberOf const.MessageConst
     */
    ID771: '実績データの取得に失敗しました。',

    /**
     * は半角英数記号で入力してください。
     * @name ID772
     * @constant
     * @memberOf const.MessageConst
     */
    ID772: 'は半角英数記号で入力してください。',

    /**
     * はひらがなで入力してください。
     * @name ID773
     * @constant
     * @memberOf const.MessageConst
     */
    ID773: 'はひらがなで入力してください。',

    /**
     * サインの情報が存在しません。
     * @name ID774
     * @constant
     * @memberOf const.MessageConst
     */
    ID774: 'サインの情報が存在しません。',

    /**
     * パスワード(確認用)の入力が、パスワードの入力と異なります。
     * @name ID775
     * @constant
     * @memberOf const.MessageConst
     */
    ID775: 'パスワード(確認用)の入力が、パスワードの入力と異なります。',

    /**
     * 電話番号は半角数字のみで入力してください。1文字目は「0」を入力してください。
     * @name ID776
     * @constant
     * @memberOf const.MessageConst
     */
    ID776:
      '電話番号は半角数字のみで入力してください。1文字目は「0」を入力してください。',

    /**
     * 指定された予約情報に確定済みの予約が含まれていたため削除できませんでした。
     * @name ID777
     * @constant
     * @memberOf const.MessageConst
     */
    ID777:
      '指定された予約情報に確定済みの予約が含まれていたため削除できませんでした。',

    /**
     * 指定された予約日は予約可能な期間ではありません。別の日時を選びなおしてください。
     * @name ID778
     * @constant
     * @memberOf const.MessageConst
     */
    ID778:
      '指定された予約日は予約可能な期間ではありません。別の日時を選びなおしてください。',

    /**
     * 検索結果が多すぎます。検索条件を変更し再度実行してください。
     * @name ID779
     * @constant
     * @memberOf const.MessageConst
     */
    ID779: '検索結果が多すぎます。検索条件を変更し再度実行してください。',

    /**
     * は半角数字・半角英字(大文字のみ) 1～3桁で入力してください。
     * @name ID780
     * @constant
     * @memberOf const.MessageConst
     */
    ID780: 'は半角数字・半角英字(大文字のみ) 1～3桁で入力してください。',

    /**
     * 内容変更時は新しい予約番号が発行されます。ご確認ください。
     * @name ID781
     * @constant
     * @memberOf const.MessageConst
     */
    ID781: '内容変更時は新しい予約番号が発行されます。ご確認ください。',

    /**
     * 予約内容を変更しました。新しい予約番号をメールまたは予約履歴からご確認ください。
     * @name ID782
     * @constant
     * @memberOf const.MessageConst
     */
    ID782:
      '予約内容を変更しました。新しい予約番号をメールまたは予約履歴からご確認ください。',

    /**
     * 予約が確定されたため、変更できない項目があります。予約一覧から予約情報を選択しなおしてください。
     * @name ID783
     * @constant
     * @memberOf const.MessageConst
     */
    ID783:
      '予約が確定されたため、変更できない項目があります。予約一覧から予約情報を選択しなおしてください。',

    /**
     * センターを選びなおしてください。
     * @name ID784
     * @constant
     * @memberOf const.MessageConst
     */
    ID784: 'センターを選びなおしてください。',

    /**
     * ログインしなおしてください。
     * @name ID785
     * @constant
     * @memberOf const.MessageConst
     */
    ID785: 'ログインしなおしてください。',

    /**
     * 対象のバースは現在作業中ですが、作業を開始してもよろしいでしょうか。
     * @name ID786
     * @constant
     * @memberOf const.MessageConst
     */
    ID786:
      '対象のバースは現在作業中ですが、作業を開始してもよろしいでしょうか。',

    /**
     * は半角英数字(小文字のみ)・半角記号(ハイフン・アンダースコアのみ)3～20桁で入力してください。<br>
     * DoCoMap連携
     * @name ID787
     * @constant
     * @memberOf const.MessageConst
     */
    ID787:
      'は半角英数字(小文字のみ)・半角記号(ハイフン・アンダースコアのみ)3～20桁で入力してください。',

    /**
     * は半角英数字(小文字のみ)・半角記号(ハイフン・アンダースコアのみ)1～7桁で入力してください。<br>
     * DoCoMap連携
     * @name ID788
     * @constant
     * @memberOf const.MessageConst
     */
    ID788:
      'は半角英数字(小文字のみ)・半角記号(ハイフン・アンダースコアのみ)1～7桁で入力してください。',

    /**
     * 時点の予測<br>
     * DoCoMap連携
     * @name ID789
     * @constant
     * @memberOf const.MessageConst
     */
    ID789: '時点の予測',

    /**
     * 測定値は半角数字で入力してください。例：36.5、36.0、36<br>
     * 検温オプション
     * @name ID790
     * @constant
     * @memberOf const.MessageConst
     */
    ID790: '測定値は半角数字で入力してください。例：36.5、36.0、36',

    /**
     * センター側の設定が変更されました。<br>
     * 検温オプション
     * @name ID791
     * @constant
     * @memberOf const.MessageConst
     */
    ID791: 'センター側の設定が変更されました。',

    /**
     * ログインしなおしてください。<br>
     * 検温オプション
     * @name ID792
     * @constant
     * @memberOf const.MessageConst
     */
    ID792: 'ログインしなおしてください。',

    /**
     * 指定された電話番号は既に使用されています。別の電話番号を入力してください。<br>
     * 検温オプション
     * @name ID793
     * @constant
     * @memberOf const.MessageConst
     */
    ID793:
      '指定された電話番号は既に使用されています。別の電話番号を入力してください。',

    /**
     * ダイヤIDを割り当てることができません。別の日時を選びなおしてください。
     * @name ID794
     * @constant
     * @memberOf const.MessageConst
     */
    ID794:
      'ダイヤIDを割り当てることができません。別の日時を選びなおしてください。',

    /**
     * ファイルのアップロードに失敗しました。一度画面を更新または別画面に遷移後にこちらの画面を再表示してファイルをアップロードしてください。
     * @name ID795
     * @constant
     * @memberOf const.MessageConst
     */
    ID795:
      'ファイルのアップロードに失敗しました。一度画面を更新または別画面に遷移後にこちらの画面を再表示してファイルをアップロードしてください。',

    /**
     * ファイルは1つだけ選択してください。
     * @name ID796
     * @constant
     * @memberOf const.MessageConst
     */
    ID796: 'ファイルは1つだけ選択してください。',

    /**
     * 開始日は現在日から翌日以降の日付を選択してください。
     * @name ID797
     * @constant
     * @memberOf const.MessageConst
     */
    ID797: '開始日は現在日から翌日以降の日付を選択してください。',

    /**
     * 開始日は、終了日より過去の日時を指定してください。
     * @name ID798
     * @constant
     * @memberOf const.MessageConst
     */
    ID798: '開始日は、終了日より過去の日時を指定してください。',

    /**
     * 開始日～終了日の期間が1カ月以内になるよう指定してください。
     * @name ID799
     * @constant
     * @memberOf const.MessageConst
     */
    ID799: '開始日～終了日の期間が1カ月以内になるよう指定してください。',

    /**
     * 2文字まで
     * @name ID800
     * @constant
     * @memberOf const.MessageConst
     */
    ID800: '2文字まで',

    /**
     * 再ログインしてやり直してください。
     * @name ID801
     * @constant
     * @memberOf const.MessageConst
     */
    ID801: '再ログインしてやり直してください。',

    /**
     * 指定された予約・受付IDは存在しません。
     * @name ID802
     * @constant
     * @memberOf const.MessageConst
     */
    ID802: '指定された予約・受付IDは存在しません。',

    /**
     * パレット枚数は半角数字1～2桁で入力してください。
     * @name ID803
     * @constant
     * @memberOf const.MessageConst
     */
    ID803: 'パレット枚数は半角数字1～2桁で入力してください。',

    /**
     * 作業開始日時は受付日時より後の時間を入力してください。
     * @name ID804
     * @constant
     * @memberOf const.MessageConst
     */
    ID804: '作業開始日時は受付日時より後の時間を入力してください。',

    /**
     * 作業終了日時は受付日時より後の時間を入力してください。
     * @name ID805
     * @constant
     * @memberOf const.MessageConst
     */
    ID805: '作業終了日時は受付日時より後の時間を入力してください。',

    /**
     * 作業終了日時は作業開始日時より後の時間を入力してください。
     * @name ID806
     * @constant
     * @memberOf const.MessageConst
     */
    ID806: '作業終了日時は作業開始日時より後の時間を入力してください。',

    /**
     * ファイルのアップロードに失敗しました。一度別の画面に移動してから、再度この画面を表示してファイルのアップロードをやり直してください。
     * @name ID807
     * @constant
     * @memberOf const.MessageConst
     */
    ID807:
      'ファイルのアップロードに失敗しました。一度別の画面に移動してから、再度この画面を表示してファイルのアップロードをやり直してください。',

    /**
     * CSV登録に時間がかかっています。継続して予定情報の登録を行っておりますので、しばらくたってから予約・受付一覧画面を表示し、再度検索しなおしてください。
     * @name ID808
     * @constant
     * @memberOf const.MessageConst
     */
    ID808:
      'CSV登録に時間がかかっています。継続して予定情報の登録を行っておりますので、しばらくたってから予約・受付一覧画面を表示し、再度検索しなおしてください。',

    /**
     * QRコードの取得に失敗しました。
     * @name ID809
     * @constant
     * @memberOf const.MessageConst
     */
    ID809: 'QRコードの取得に失敗しました。',

    /**
     * マスタリストを選択してください。
     * @name ID810
     * @constant
     * @memberOf const.MessageConst
     */
    ID810: 'マスタリストを選択してください。',

    /**
     * CSVデータの登録が完了しました。
     * @name ID811
     * @constant
     * @memberOf const.MessageConst
     */
    ID811: 'CSVデータの登録が完了しました。',

    /**
     * 登録に時間がかかっています。継続して登録を行っておりますので、しばらくお待ちください。
     * @name ID812
     * @constant
     * @memberOf const.MessageConst
     */
    ID812:
      '登録に時間がかかっています。継続して登録を行っておりますので、しばらくお待ちください。',

    /**
     * 割当バースがバース種別と紐づかないため、仕入先/出荷先名と記号グループの組み合わせを変更してください。
     * @name ID813
     * @constant
     * @memberOf const.MessageConst
     */
    ID813:
      '割当バースがバース種別と紐づかないため、仕入先/出荷先名と記号グループの組み合わせを変更してください。',

    /**
     * 予約受付内容を変更しました。
     * @name ID814
     * @constant
     * @memberOf const.MessageConst
     */
    ID814: '予約受付内容を変更しました。',

    /**
     * 割当バースが存在しないため、仕入先/出荷先名と記号グループの組み合わせを変更してください。
     * @name ID815
     * @constant
     * @memberOf const.MessageConst
     */
    ID815:
      '割当バースが存在しないため、仕入先/出荷先名と記号グループの組み合わせを変更してください。'
  },

  MY_PAGE: {
    /**
     * アカウント情報編集
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: 'アカウント情報編集',

    /**
     * ログインID
     * @name ID021
     * @constant
     * @memberOf const.MessageConst
     */
    ID021: 'ログインID',

    /**
     * ユーザー名
     * @name ID022
     * @constant
     * @memberOf const.MessageConst
     */
    ID022: 'ユーザー名',

    /**
     * メールアドレス
     * @name ID023
     * @constant
     * @memberOf const.MessageConst
     */
    ID023: 'メールアドレス',

    /**
     * パスワードを変更する
     * @name ID024
     * @constant
     * @memberOf const.MessageConst
     */
    ID024: 'パスワードを変更する',

    /**
     * 現在のパスワード
     * @name ID025
     * @constant
     * @memberOf const.MessageConst
     */
    ID025: '現在のパスワード',

    /**
     * 新しいパスワード
     * @name ID026
     * @constant
     * @memberOf const.MessageConst
     */
    ID026: '新しいパスワード',

    /**
     * （再確認）
     * @name ID027
     * @constant
     * @memberOf const.MessageConst
     */
    ID027: '（再確認）',

    /**
     * キャンセル
     * @name ID031
     * @constant
     * @memberOf const.MessageConst
     */
    ID031: 'キャンセル',

    /**
     * 変更
     * @name ID032
     * @constant
     * @memberOf const.MessageConst
     */
    ID032: '変更',

    /**
     * 配送会社名
     * @name ID033
     * @constant
     * @memberOf const.MessageConst
     */
    ID033: '配送会社名',

    /**
     * 運送会社名
     * @name ID034
     * @constant
     * @memberOf const.MessageConst
     */
    ID034: '運送会社名',

    /**
     * 電話番号
     * @name ID035
     * @constant
     * @memberOf const.MessageConst
     */
    ID035: '電話番号',

    /**
     * QRコード表示
     * @name ID036
     * @constant
     * @memberOf const.MessageConst
     */
    ID036: 'QRコード表示'
  },

  REQUEST_COMMON: {
    /**
     * 」または「
     * @name ID012
     * @constant
     * @memberOf const.MessageConst
     */
    ID012: '」または「',

    /**
     * 」を選ぶと、予約の登録ができます。
     * @name ID013
     * @constant
     * @memberOf const.MessageConst
     */
    ID013: '」を選ぶと、予約の登録ができます。',

    /**
     * 「
     * @name ID014
     * @constant
     * @memberOf const.MessageConst
     */
    ID014: '「',

    /**
     * 」「
     * @name ID015
     * @constant
     * @memberOf const.MessageConst
     */
    ID015: '」「',

    /**
     * 」は予約できません。
     * @name ID016
     * @constant
     * @memberOf const.MessageConst
     */
    ID016: '」は予約できません。',

    /**
     * 現在の予約数
     * @name ID017
     * @constant
     * @memberOf const.MessageConst
     */
    ID017: '現在の予約数',

    /**
     * [凡例]
     * @name ID018
     * @constant
     * @memberOf const.MessageConst
     */
    ID018: '[凡例]',

    /**
     * 予約なし
     * @name ID019
     * @constant
     * @memberOf const.MessageConst
     */
    ID019: '予約なし',

    /**
     * 予約中
     * @name ID020
     * @constant
     * @memberOf const.MessageConst
     */
    ID020: '予約中',

    /**
     * 予約件数()
     * @name ID021
     * @constant
     * @memberOf const.MessageConst
     */
    ID021: '予約件数()',

    /**
     * ()内は未確定の予約件数
     * @name ID022
     * @constant
     * @memberOf const.MessageConst
     */
    ID022: '()内は未確定の予約件数',

    /**
     * 表示
     * @name ID024
     * @constant
     * @memberOf const.MessageConst
     */
    ID024: '表示',

    /**
     * ○
     * @name ID025
     * @constant
     * @memberOf const.MessageConst
     */
    ID025: '○',

    /**
     * ▲
     * @name ID026
     * @constant
     * @memberOf const.MessageConst
     */
    ID026: '▲',

    /**
     * 満
     * @name ID027
     * @constant
     * @memberOf const.MessageConst
     */
    ID027: '満',

    /**
     * 空き
     * @name ID028
     * @constant
     * @memberOf const.MessageConst
     */
    ID028: '空き',

    /**
     * 一部空き
     * @name ID029
     * @constant
     * @memberOf const.MessageConst
     */
    ID029: '一部空き',

    /**
     * 空き無し
     * @name ID030
     * @constant
     * @memberOf const.MessageConst
     */
    ID030: '空き無し',

    /**
     * (
     * @name ID031
     * @constant
     * @memberOf const.MessageConst
     */
    ID031: '(',

    /**
     * )
     * @name ID032
     * @constant
     * @memberOf const.MessageConst
     */
    ID032: ')',

    /**
     * 件
     * @name ID033
     * @constant
     * @memberOf const.MessageConst
     */
    ID033: '件',

    /**
     * 予約日時
     * @name ID101
     * @constant
     * @memberOf const.MessageConst
     */
    ID101: '予約日時',

    /**
     * ステータス
     * @name ID102
     * @constant
     * @memberOf const.MessageConst
     */
    ID102: 'ステータス',

    /**
     * バース種別
     * @name ID103
     * @constant
     * @memberOf const.MessageConst
     */
    ID103: 'バース種別',

    /**
     * センター
     * @name ID104
     * @constant
     * @memberOf const.MessageConst
     */
    ID104: 'センター',

    /**
     * 積み方
     * @name ID105
     * @constant
     * @memberOf const.MessageConst
     */
    ID105: '積み方',

    /**
     * 作業時間目安
     * @name ID106
     * @constant
     * @memberOf const.MessageConst
     */
    ID106: '作業時間目安',

    /**
     * ウィングの有無
     * @name ID107
     * @constant
     * @memberOf const.MessageConst
     */
    ID107: 'ウィングの有無',

    /**
     * 車種
     * @name ID108
     * @constant
     * @memberOf const.MessageConst
     */
    ID108: '車種',

    /**
     * 車両番号
     * @name ID109
     * @constant
     * @memberOf const.MessageConst
     */
    ID109: '車両番号',

    /**
     * 陸運支局
     * @name ID110
     * @constant
     * @memberOf const.MessageConst
     */
    ID110: '陸運支局',

    /**
     * 分類番号
     * @name ID111
     * @constant
     * @memberOf const.MessageConst
     */
    ID111: '分類番号',

    /**
     * 用途コード
     * @name ID112
     * @constant
     * @memberOf const.MessageConst
     */
    ID112: '用途コード',

    /**
     * 一連番号
     * @name ID113
     * @constant
     * @memberOf const.MessageConst
     */
    ID113: '一連番号',

    /**
     * 運送会社名
     * @name ID114
     * @constant
     * @memberOf const.MessageConst
     */
    ID114: '運送会社名',

    /**
     * ドライバー名
     * @name ID115
     * @constant
     * @memberOf const.MessageConst
     */
    ID115: 'ドライバー名',

    /**
     * ドライバー電話番号
     * @name ID116
     * @constant
     * @memberOf const.MessageConst
     */
    ID116: 'ドライバー電話番号',

    /**
     * ドライバーメールアドレス
     * @name ID117
     * @constant
     * @memberOf const.MessageConst
     */
    ID117: 'ドライバーメールアドレス',

    /**
     * 備考
     * @name ID118
     * @constant
     * @memberOf const.MessageConst
     */
    ID118: '備考',

    /**
     * 添付ファイル
     * @name ID119
     * @constant
     * @memberOf const.MessageConst
     */
    ID119: '添付ファイル',

    /**
     * 最大5ファイルまでアップロードできます。
     * @name ID120
     * @constant
     * @memberOf const.MessageConst
     */
    ID120: '最大5ファイルまでアップロードできます。',

    /**
     * 選択
     * @name ID121
     * @constant
     * @memberOf const.MessageConst
     */
    ID121: '選択',

    /**
     * 計算
     * @name ID122
     * @constant
     * @memberOf const.MessageConst
     */
    ID122: '計算',

    /**
     * メールアドレスを追加
     * @name ID123
     * @constant
     * @memberOf const.MessageConst
     */
    ID123: 'メールアドレスを追加',

    /**
     * 参照
     * @name ID124
     * @constant
     * @memberOf const.MessageConst
     */
    ID124: '参照',

    /**
     * 削除
     * @name ID125
     * @constant
     * @memberOf const.MessageConst
     */
    ID125: '削除',

    /**
     * アップロードファイルを追加
     * @name ID126
     * @constant
     * @memberOf const.MessageConst
     */
    ID126: 'アップロードファイルを追加',

    /**
     * キャンセル
     * @name ID127
     * @constant
     * @memberOf const.MessageConst
     */
    ID127: 'キャンセル',

    /**
     * 検索
     * @name ID128
     * @constant
     * @memberOf const.MessageConst
     */
    ID128: '検索',

    /**
     * ドライバー情報
     * @name ID129
     * @constant
     * @memberOf const.MessageConst
     */
    ID129: 'ドライバー情報',

    /**
     * 電話番号
     * @name ID130
     * @constant
     * @memberOf const.MessageConst
     */
    ID130: '電話番号',

    /**
     * メールアドレス
     * @name ID131
     * @constant
     * @memberOf const.MessageConst
     */
    ID131: 'メールアドレス',

    /**
     * OK
     * @name ID132
     * @constant
     * @memberOf const.MessageConst
     */
    ID132: 'OK',

    /**
     * 閉じる
     * @name ID133
     * @constant
     * @memberOf const.MessageConst
     */
    ID133: '閉じる',

    /**
     * 予約状況
     * @name ID134
     * @constant
     * @memberOf const.MessageConst
     */
    ID134: '予約状況',

    /**
     * オプション
     * @name ID135
     * @constant
     * @memberOf const.MessageConst
     */
    ID135: 'オプション',

    /**
     * 不明
     * @name ID136
     * @constant
     * @memberOf const.MessageConst
     */
    ID136: '不明',

    /**
     * バース名
     * @name ID137
     * @constant
     * @memberOf const.MessageConst
     */
    ID137: 'バース名',

    /**
     * 予約ID
     * @name ID138
     * @constant
     * @memberOf const.MessageConst
     */
    ID138: '予約ID',

    /**
     * サンプルはこちら
     * @name ID139
     * @constant
     * @memberOf const.MessageConst
     */
    ID139: 'サンプルはこちら',

    /**
     * 事前予約番号
     * @name ID140
     * @constant
     * @memberOf const.MessageConst
     */
    ID140: '事前予約番号',

    /**
     * 品名
     * @name ID141
     * @constant
     * @memberOf const.MessageConst
     */
    ID141: '品名',

    /**
     * 仕入先/出荷先名
     * @name ID142
     * @constant
     * @memberOf const.MessageConst
     */
    ID142: '仕入先/出荷先名',

    /**
     * DoCoMap<br>
     * DoCoMap連携
     * @name ID143
     * @constant
     * @memberOf const.MessageConst
     */
    ID143: 'DoCoMap',

    /**
     * 企業コード<br>
     * DoCoMap連携
     * @name ID144
     * @constant
     * @memberOf const.MessageConst
     */
    ID144: '企業コード',

    /**
     * 端末コード<br>
     * DoCoMap連携
     * @name ID145
     * @constant
     * @memberOf const.MessageConst
     */
    ID145: '端末コード',

    /**
     * 到着予測時間<br>
     * DoCoMap連携
     * @name ID146
     * @constant
     * @memberOf const.MessageConst
     */
    ID146: '到着予測時間',

    /**
     * 仕入先/出荷先名
     * @name ID147
     * @constant
     * @memberOf const.MessageConst
     */
    ID147: '仕入先/出荷先名',

    /**
     * バース種別
     * @name ID148
     * @constant
     * @memberOf const.MessageConst
     */
    ID148: 'バース種別',

    /**
     * 予定開始時間
     * @name ID149
     * @constant
     * @memberOf const.MessageConst
     */
    ID149: '予定開始時間',

    /**
     * 予定終了時間
     * @name ID150
     * @constant
     * @memberOf const.MessageConst
     */
    ID150: '予定終了時間',

    /**
     * 記号グループ
     * @name ID151
     * @constant
     * @memberOf const.MessageConst
     */
    ID151: '記号グループ',

    /**
     * パレット枚数
     * @name ID152
     * @constant
     * @memberOf const.MessageConst
     */
    ID152: 'パレット枚数'
  },
  REQUEST_DATE_SELECT: {
    /**
     * ≪
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: '≪',

    /**
     * ≫
     * @name ID012
     * @constant
     * @memberOf const.MessageConst
     */
    ID012: '≫',

    /**
     * 予約したい日の「
     * @name ID020
     * @constant
     * @memberOf const.MessageConst
     */
    ID020: '予約したい日の「'
  },
  REQUEST_TIME_SELECT: {
    /**
     * 利用日
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: '利用日',

    /**
     * 利用時間
     * @name ID012
     * @constant
     * @memberOf const.MessageConst
     */
    ID012: '利用時間',

    /**
     * 予約したい時間の「
     * @name ID020
     * @constant
     * @memberOf const.MessageConst
     */
    ID020: '予約したい時間の「'
  },
  REQUEST_LIST: {
    /**
     * 予約一覧
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: '予約一覧',

    /**
     * 開始日
     * @name ID021
     * @constant
     * @memberOf const.MessageConst
     */
    ID021: '開始日',

    /**
     * 終了日
     * @name ID022
     * @constant
     * @memberOf const.MessageConst
     */
    ID022: '終了日',

    /**
     * 検索
     * @name ID031
     * @constant
     * @memberOf const.MessageConst
     */
    ID031: '検索',

    /**
     * 検索結果を出力
     * @name ID032
     * @constant
     * @memberOf const.MessageConst
     */
    ID032: '検索結果を出力',

    /**
     * センター名
     * @name ID041
     * @constant
     * @memberOf const.MessageConst
     */
    ID041: 'センター名',

    /**
     * メーカー名
     * @name ID044
     * @constant
     * @memberOf const.MessageConst
     */
    ID044: 'メーカー名',

    /**
     * 添付
     * @name ID045
     * @constant
     * @memberOf const.MessageConst
     */
    ID045: '添付',

    /**
     * 詳細
     * @name ID051
     * @constant
     * @memberOf const.MessageConst
     */
    ID051: '詳細',

    /**
     * 選択した予約を削除
     * @name ID061
     * @constant
     * @memberOf const.MessageConst
     */
    ID061: '選択した予約を削除'
  },
  REQUEST_REGIST: {
    /**
     * 予約登録
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: '予約登録',

    /**
     * 登録
     * @name ID021
     * @constant
     * @memberOf const.MessageConst
     */
    ID021: '登録'
  },
  REQUEST_CONFIRMATION: {
    /**
     * 予約詳細
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: '予約詳細',

    /**
     * ダウンロード
     * @name ID021
     * @constant
     * @memberOf const.MessageConst
     */
    ID021: 'ダウンロード',

    /**
     * 戻る
     * @name ID031
     * @constant
     * @memberOf const.MessageConst
     */
    ID031: '戻る',

    /**
     * 内容を変更する
     * @name ID032
     * @constant
     * @memberOf const.MessageConst
     */
    ID032: '内容を変更する'
  },
  REQUEST_EDIT: {
    /**
     * 予約編集
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: '予約編集',

    /**
     * 変更
     * @name ID021
     * @constant
     * @memberOf const.MessageConst
     */
    ID021: '変更'
  },

  BOOKING_COMMON: {
    /**
     * 予約日時
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: '予約日時',

    /**
     * ステータス
     * @name ID012
     * @constant
     * @memberOf const.MessageConst
     */
    ID012: 'ステータス',

    /**
     * バース種別
     * @name ID013
     * @constant
     * @memberOf const.MessageConst
     */
    ID013: 'バース種別',

    /**
     * 積み方
     * @name ID015
     * @constant
     * @memberOf const.MessageConst
     */
    ID015: '積み方',

    /**
     * ウィングの有無
     * @name ID016
     * @constant
     * @memberOf const.MessageConst
     */
    ID016: 'ウィングの有無',

    /**
     * 作業時間目安
     * @name ID017
     * @constant
     * @memberOf const.MessageConst
     */
    ID017: '作業時間目安',

    /**
     * 車種
     * @name ID018
     * @constant
     * @memberOf const.MessageConst
     */
    ID018: '車種',

    /**
     * 車両番号
     * @name ID019
     * @constant
     * @memberOf const.MessageConst
     */
    ID019: '車両番号',

    /**
     * 陸運支局
     * @name ID020
     * @constant
     * @memberOf const.MessageConst
     */
    ID020: '陸運支局',

    /**
     * 分類番号
     * @name ID021
     * @constant
     * @memberOf const.MessageConst
     */
    ID021: '分類番号',

    /**
     * 用途コード
     * @name ID022
     * @constant
     * @memberOf const.MessageConst
     */
    ID022: '用途コード',

    /**
     * 一連番号
     * @name ID023
     * @constant
     * @memberOf const.MessageConst
     */
    ID023: '一連番号',

    /**
     * 配送会社名
     * @name ID024
     * @constant
     * @memberOf const.MessageConst
     */
    ID024: '配送会社名',

    /**
     * 運送会社名
     * @name ID025
     * @constant
     * @memberOf const.MessageConst
     */
    ID025: '運送会社名',

    /**
     * ドライバー名
     * @name ID026
     * @constant
     * @memberOf const.MessageConst
     */
    ID026: 'ドライバー名',

    /**
     * ドライバー電話番号
     * @name ID027
     * @constant
     * @memberOf const.MessageConst
     */
    ID027: 'ドライバー電話番号',

    /**
     * ドライバーメールアドレス
     * @name ID028
     * @constant
     * @memberOf const.MessageConst
     */
    ID028: 'ドライバーメールアドレス',

    /**
     * 備考
     * @name ID029
     * @constant
     * @memberOf const.MessageConst
     */
    ID029: '備考',

    /**
     * 添付ファイル
     * @name ID030
     * @constant
     * @memberOf const.MessageConst
     */
    ID030: '添付ファイル',

    /**
     * 最大5ファイルまでアップロードできます。
     * @name ID031
     * @constant
     * @memberOf const.MessageConst
     */
    ID031: '最大5ファイルまでアップロードできます。',

    /**
     * 選択
     * @name ID032
     * @constant
     * @memberOf const.MessageConst
     */
    ID032: '選択',

    /**
     * メールアドレスを追加
     * @name ID033
     * @constant
     * @memberOf const.MessageConst
     */
    ID033: 'メールアドレスを追加',

    /**
     * 参照
     * @name ID034
     * @constant
     * @memberOf const.MessageConst
     */
    ID034: '参照',

    /**
     * 削除
     * @name ID035
     * @constant
     * @memberOf const.MessageConst
     */
    ID035: '削除',

    /**
     * アップロードファイルを追加
     * @name ID036
     * @constant
     * @memberOf const.MessageConst
     */
    ID036: 'アップロードファイルを追加',

    /**
     * キャンセル
     * @name ID037
     * @constant
     * @memberOf const.MessageConst
     */
    ID037: 'キャンセル',

    /**
     * あり
     * @name ID038
     * @constant
     * @memberOf const.MessageConst
     */
    ID038: 'あり',

    /**
     * なし
     * @name ID039
     * @constant
     * @memberOf const.MessageConst
     */
    ID039: 'なし',

    /**
     * バース名
     * @name ID040
     * @constant
     * @memberOf const.MessageConst
     */
    ID040: 'バース名',

    /**
     * 予約ID
     * @name ID041
     * @constant
     * @memberOf const.MessageConst
     */
    ID041: '予約ID',

    /**
     * 事前予約番号
     * @name ID042
     * @constant
     * @memberOf const.MessageConst
     */
    ID042: '事前予約番号',

    /**
     * 品名
     * @name ID043
     * @constant
     * @memberOf const.MessageConst
     */
    ID043: '品名',

    /**
     * 仕入先/出荷先名
     * @name ID044
     * @constant
     * @memberOf const.MessageConst
     */
    ID044: '仕入先/出荷先名',

    /**
     * DoCoMap<br>
     * DoCoMap連携
     * @name ID046
     * @constant
     * @memberOf const.MessageConst
     */
    ID046: 'DoCoMap',

    /**
     * 企業コード<br>
     * DoCoMap連携
     * @name ID047
     * @constant
     * @memberOf const.MessageConst
     */
    ID047: '企業コード',

    /**
     * 端末コード<br>
     * DoCoMap連携
     * @name ID048
     * @constant
     * @memberOf const.MessageConst
     */
    ID048: '端末コード',

    /**
     * 到着予測時間<br>
     * DoCoMap連携
     * @name ID049
     * @constant
     * @memberOf const.MessageConst
     */
    ID049: '到着予測時間'
  },
  BOOKING_ASSIGN: {
    /**
     * 「バース種別」を選択してください。
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: '「バース種別」を選択してください。',

    /**
     * 仮予約
     * @name ID021
     * @constant
     * @memberOf const.MessageConst
     */
    ID021: '仮予約',

    /**
     * 予約
     * @name ID022
     * @constant
     * @memberOf const.MessageConst
     */
    ID022: '予約',

    /**
     * 予約確定
     * @name ID023
     * @constant
     * @memberOf const.MessageConst
     */
    ID023: '予約確定',

    /**
     * 作業中
     * @name ID024
     * @constant
     * @memberOf const.MessageConst
     */
    ID024: '作業中',

    /**
     * 作業終了
     * @name ID025
     * @constant
     * @memberOf const.MessageConst
     */
    ID025: '作業終了',

    /**
     * 遅延中
     * @name ID026
     * @constant
     * @memberOf const.MessageConst
     */
    ID026: '遅延中',

    /**
     * 待機中<br>
     * 日本トランスシティ カスタマイズ
     * @name ID027
     * @constant
     * @memberOf const.MessageConst
     */
    ID027: '待機中',

    /**
     * 臨時便<br>
     * 日本トランスシティ カスタマイズ
     * @name ID028
     * @constant
     * @memberOf const.MessageConst
     */
    ID028: '臨時便',

    /**
     * 利用日
     * @name ID031
     * @constant
     * @memberOf const.MessageConst
     */
    ID031: '利用日',

    /**
     * 利用時間
     * @name ID032
     * @constant
     * @memberOf const.MessageConst
     */
    ID032: '利用時間',

    /**
     * 前日<br>
     * 日本トランスシティ カスタマイズ
     * @name ID033
     * @constant
     * @memberOf const.MessageConst
     */
    ID033: '前日',

    /**
     * 翌日<br>
     * 日本トランスシティ カスタマイズ
     * @name ID034
     * @constant
     * @memberOf const.MessageConst
     */
    ID034: '翌日',

    /**
     * 未割
     * @name ID041
     * @constant
     * @memberOf const.MessageConst
     */
    ID041: '未割',

    /**
     * 未割当予約
     * @name ID051
     * @constant
     * @memberOf const.MessageConst
     */
    ID051: '未割当予約',

    /**
     * 予約詳細
     * @name ID061
     * @constant
     * @memberOf const.MessageConst
     */
    ID061: '予約詳細',

    /**
     * ダウンロード
     * @name ID062
     * @constant
     * @memberOf const.MessageConst
     */
    ID062: 'ダウンロード',

    /**
     * 利用バース数
     * @name ID063
     * @constant
     * @memberOf const.MessageConst
     */
    ID063: '利用バース数',

    /**
     * 編集
     * @name ID064
     * @constant
     * @memberOf const.MessageConst
     */
    ID064: '編集',

    /**
     * この予約を未割当
     * @name ID065
     * @constant
     * @memberOf const.MessageConst
     */
    ID065: 'この予約を未割当',

    /**
     * この予約だけ確定
     * @name ID066
     * @constant
     * @memberOf const.MessageConst
     */
    ID066: 'この予約だけ確定',

    /**
     * 一括
     * @name ID067
     * @constant
     * @memberOf const.MessageConst
     */
    ID067: '一括',

    /**
     * 現在地をマップに表示
     * @name ID068
     * @constant
     * @memberOf const.MessageConst
     */
    ID068: '現在地をマップに表示',

    /**
     * バース種別
     * @name ID071
     * @constant
     * @memberOf const.MessageConst
     */
    ID071: 'バース種別',

    /**
     * 表示
     * @name ID072
     * @constant
     * @memberOf const.MessageConst
     */
    ID072: '表示',

    /**
     * 一括登録<br>
     * 日本トランスシティ カスタマイズ
     * @name ID073
     * @constant
     * @memberOf const.MessageConst
     */
    ID073: '一括登録',

    /**
     * 割当を解除する予約を、ここにドラッグ＆ドロップしてください。
     * @name ID080
     * @constant
     * @memberOf const.MessageConst
     */
    ID080: '割当を解除する予約を、ここにドラッグ＆ドロップしてください。',

    /**
     * 予約をダブルクリックすると、詳細情報を表示します。
     * @name ID081
     * @constant
     * @memberOf const.MessageConst
     */
    ID081: '予約をダブルクリックすると、詳細情報を表示します。',

    /**
     * 現在地をマップに表示ボタンをクリックしてください。
     * @name ID082
     * @constant
     * @memberOf const.MessageConst
     */
    ID082: '現在地をマップに表示ボタンをクリックしてください。',

    /**
     * ここにマップが表示されます。
     * @name ID083
     * @constant
     * @memberOf const.MessageConst
     */
    ID083: 'ここにマップが表示されます。',

    /**
     * 選択した利用日の予約のみ時間とバースの変更が可能です。<br>
     * 日本トランスシティ カスタマイズ
     * @name ID084
     * @constant
     * @memberOf const.MessageConst
     */
    ID084: '選択した利用日の予約のみ時間とバースの変更が可能です。'
  },
  BOOKING_LIST: {
    /**
     * 予約一覧
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: '予約一覧',

    /**
     * 開始日
     * @name ID021
     * @constant
     * @memberOf const.MessageConst
     */
    ID021: '開始日',

    /**
     * 終了日
     * @name ID022
     * @constant
     * @memberOf const.MessageConst
     */
    ID022: '終了日',

    /**
     * 検索
     * @name ID031
     * @constant
     * @memberOf const.MessageConst
     */
    ID031: '検索',

    /**
     * 検索結果を出力
     * @name ID032
     * @constant
     * @memberOf const.MessageConst
     */
    ID032: '検索結果を出力',

    /**
     * 予約日時
     * @name ID041
     * @constant
     * @memberOf const.MessageConst
     */
    ID041: '予約日時',

    /**
     * 運送会社名
     * @name ID043
     * @constant
     * @memberOf const.MessageConst
     */
    ID043: '運送会社名',

    /**
     * 添付
     * @name ID044
     * @constant
     * @memberOf const.MessageConst
     */
    ID044: '添付',

    /**
     * 詳細
     * @name ID045
     * @constant
     * @memberOf const.MessageConst
     */
    ID045: '詳細',

    /**
     * 編集
     * @name ID046
     * @constant
     * @memberOf const.MessageConst
     */
    ID046: '編集',

    /**
     * 選択した予約を削除
     * @name ID048
     * @constant
     * @memberOf const.MessageConst
     */
    ID048: '選択した予約を削除',

    /**
     * 到着予測時間<br>
     * DoCoMap連携
     * @name ID049
     * @constant
     * @memberOf const.MessageConst
     */
    ID049: '到着予測時間'
  },
  BOOKING_CONFIRMATION: {
    /**
     * 予約確認
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: '予約確認',

    /**
     * ダウンロード
     * @name ID021
     * @constant
     * @memberOf const.MessageConst
     */
    ID021: 'ダウンロード',

    /**
     * 戻る
     * @name ID031
     * @constant
     * @memberOf const.MessageConst
     */
    ID031: '戻る',

    /**
     * 内容を変更する
     * @name ID032
     * @constant
     * @memberOf const.MessageConst
     */
    ID032: '内容を変更する'
  },
  BOOKING_EDIT: {
    /**
     * 予約編集
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: '予約編集',

    /**
     * 変更
     * @name ID021
     * @constant
     * @memberOf const.MessageConst
     */
    ID021: '変更'
  },
  BOOKING_CSV_REGIST: {
    /**
     * 予約一括登録
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: '予約一括登録',

    /**
     * 期間を指定し、CSVファイルを選択してください。
     * @name ID021
     * @constant
     * @memberOf const.MessageConst
     */
    ID021: '期間を指定し、CSVファイルを選択してください。',

    /**
     * 開始日
     * @name ID031
     * @constant
     * @memberOf const.MessageConst
     */
    ID031: '開始日',

    /**
     * 終了日
     * @name ID041
     * @constant
     * @memberOf const.MessageConst
     */
    ID041: '終了日',

    /**
     * 配送会社で登録した予約情報が存在する場合は上書きする
     * @name ID051
     * @constant
     * @memberOf const.MessageConst
     */
    ID051: '配送会社で登録した予約情報が存在する場合は上書きする',

    /**
     * ファイルを選択
     * @name ID061
     * @constant
     * @memberOf const.MessageConst
     */
    ID061: 'ファイルを選択',

    /**
     * 選択されていません。
     * @name ID071
     * @constant
     * @memberOf const.MessageConst
     */
    ID071: '選択されていません。',

    /**
     * キャンセル
     * @name ID081
     * @constant
     * @memberOf const.MessageConst
     */
    ID081: 'キャンセル',

    /**
     * 登録
     * @name ID091
     * @constant
     * @memberOf const.MessageConst
     */
    ID091: '登録',

    /**
     * ※上書きするにチェックを入れた場合は、対象期間内に存在する配送会社で登録した予約情報はすべて削除されます。
     * @name ID092
     * @constant
     * @memberOf const.MessageConst
     */
    ID092:
      '※上書きするにチェックを入れた場合は、対象期間内に存在する配送会社で登録した予約情報はすべて削除されます。'
  },
  CONTRACTOR_COMMON: {
    /**
     * 配送会社名
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: '配送会社名',

    /**
     * 利用状況
     * @name ID012
     * @constant
     * @memberOf const.MessageConst
     */
    ID012: '利用状況',

    /**
     * 担当者名
     * @name ID013
     * @constant
     * @memberOf const.MessageConst
     */
    ID013: '担当者名',

    /**
     * 利用中
     * @name ID014
     * @constant
     * @memberOf const.MessageConst
     */
    ID014: '利用中',

    /**
     * 停止中
     * @name ID015
     * @constant
     * @memberOf const.MessageConst
     */
    ID015: '停止中'
  },
  CONTRACTOR_LIST: {
    /**
     * 配送会社一覧
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: '配送会社一覧',

    /**
     * 検索
     * @name ID021
     * @constant
     * @memberOf const.MessageConst
     */
    ID021: '検索',

    /**
     * 検索結果を出力
     * @name ID022
     * @constant
     * @memberOf const.MessageConst
     */
    ID022: '検索結果を出力',

    /**
     * 詳細
     * @name ID031
     * @constant
     * @memberOf const.MessageConst
     */
    ID031: '詳細',

    /**
     * 編集
     * @name ID032
     * @constant
     * @memberOf const.MessageConst
     */
    ID032: '編集',

    /**
     * 選択した会社を削除
     * @name ID041
     * @constant
     * @memberOf const.MessageConst
     */
    ID041: '選択した会社を削除'
  },
  CONTRACTOR_CONFIRMATION: {
    /**
     * 配送会社確認
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: '配送会社確認',

    /**
     * 戻る
     * @name ID021
     * @constant
     * @memberOf const.MessageConst
     */
    ID021: '戻る',

    /**
     * 内容を変更する
     * @name ID022
     * @constant
     * @memberOf const.MessageConst
     */
    ID022: '内容を変更する'
  },
  CONTRACTOR_PERMIT: {
    /**
     * 配送会社承認
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: '配送会社承認',

    /**
     * 再開する
     * @name ID021
     * @constant
     * @memberOf const.MessageConst
     */
    ID021: '再開する',

    /**
     * 停止する
     * @name ID022
     * @constant
     * @memberOf const.MessageConst
     */
    ID022: '停止する',

    /**
     * キャンセル
     * @name ID031
     * @constant
     * @memberOf const.MessageConst
     */
    ID031: 'キャンセル',

    /**
     * 変更
     * @name ID032
     * @constant
     * @memberOf const.MessageConst
     */
    ID032: '変更'
  },
  USER_COMMON: {
    /**
     * ユーザー名
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: 'ユーザー名',

    /**
     * ログインID
     * @name ID012
     * @constant
     * @memberOf const.MessageConst
     */
    ID012: 'ログインID',

    /**
     * 権限
     * @name ID013
     * @constant
     * @memberOf const.MessageConst
     */
    ID013: '権限',

    /**
     * パスワード
     * @name ID014
     * @constant
     * @memberOf const.MessageConst
     */
    ID014: 'パスワード',

    /**
     * （確認用）
     * @name ID015
     * @constant
     * @memberOf const.MessageConst
     */
    ID015: '（確認用）',

    /**
     * キャンセル
     * @name ID016
     * @constant
     * @memberOf const.MessageConst
     */
    ID016: 'キャンセル',

    /**
     * メールアドレス
     * @name ID017
     * @constant
     * @memberOf const.MessageConst
     */
    ID017: 'メールアドレス',

    /**
     * システム管理者
     * @name ID018
     * @constant
     * @memberOf const.MessageConst
     */
    ID018: 'システム管理者',

    /**
     * センター管理者
     * @name ID019
     * @constant
     * @memberOf const.MessageConst
     */
    ID019: 'センター管理者',

    /**
     * バース作業員
     * @name ID020
     * @constant
     * @memberOf const.MessageConst
     */
    ID020: 'バース作業員',

    /**
     * 配送業者
     * @name ID021
     * @constant
     * @memberOf const.MessageConst
     */
    ID021: '配送業者',

    /**
     * ドライバー
     * @name ID022
     * @constant
     * @memberOf const.MessageConst
     */
    ID022: 'ドライバー',

    /**
     * ※半角スペースは入力しないでください。
     * @name ID023
     * @constant
     * @memberOf const.MessageConst
     */
    ID023: '※半角スペースは入力しないでください。'
  },
  USER_LIST: {
    /**
     * ユーザー一覧
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: 'ユーザー一覧',

    /**
     * 検索
     * @name ID021
     * @constant
     * @memberOf const.MessageConst
     */
    ID021: '検索',

    /**
     * 検索結果を出力
     * @name ID022
     * @constant
     * @memberOf const.MessageConst
     */
    ID022: '検索結果を出力',

    /**
     * 新規登録
     * @name ID031
     * @constant
     * @memberOf const.MessageConst
     */
    ID031: '新規登録',

    /**
     * 詳細
     * @name ID041
     * @constant
     * @memberOf const.MessageConst
     */
    ID041: '詳細',

    /**
     * 編集
     * @name ID042
     * @constant
     * @memberOf const.MessageConst
     */
    ID042: '編集',

    /**
     * 選択したユーザーを削除
     * @name ID051
     * @constant
     * @memberOf const.MessageConst
     */
    ID051: '選択したユーザーを削除'
  },
  USER_REGIST: {
    /**
     * ユーザー登録
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: 'ユーザー登録',

    /**
     * 登録
     * @name ID021
     * @constant
     * @memberOf const.MessageConst
     */
    ID021: '登録'
  },
  USER_CONFIRMATION: {
    /**
     * ユーザー詳細
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: 'ユーザー詳細',

    /**
     * 戻る
     * @name ID021
     * @constant
     * @memberOf const.MessageConst
     */
    ID021: '戻る',

    /**
     * 内容を変更する
     * @name ID022
     * @constant
     * @memberOf const.MessageConst
     */
    ID022: '内容を変更する'
  },
  USER_EDIT: {
    /**
     * ユーザー編集
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: 'ユーザー編集',

    /**
     * 変更
     * @name ID021
     * @constant
     * @memberOf const.MessageConst
     */
    ID021: '変更',

    /**
     * パスワードを変更する
     * @name ID031
     * @constant
     * @memberOf const.MessageConst
     */
    ID031: 'パスワードを変更する'
  },
  BERTH_SETTING: {
    /**
     * バース設定
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: 'バース設定',

    /**
     * バース設定一覧
     * @name ID021
     * @constant
     * @memberOf const.MessageConst
     */
    ID021: 'バース設定一覧',

    /**
     * バース種別
     * @name ID031
     * @constant
     * @memberOf const.MessageConst
     */
    ID031: 'バース種別',

    /**
     * 車種
     * @name ID032
     * @constant
     * @memberOf const.MessageConst
     */
    ID032: '車種',

    /**
     * 作業時間
     * @name ID033
     * @constant
     * @memberOf const.MessageConst
     */
    ID033: '作業時間',

    /**
     * 設定
     * @name ID041
     * @constant
     * @memberOf const.MessageConst
     */
    ID041: '設定',

    /**
     * 詳細
     * @name ID042
     * @constant
     * @memberOf const.MessageConst
     */
    ID042: '詳細'
  },
  ACCOUNTABLE_TIME_SETTING: {
    /**
     * 利用可能時間編集
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: '利用可能時間編集',

    /**
     * 予約開始時間
     * @name ID021
     * @constant
     * @memberOf const.MessageConst
     */
    ID021: '予約開始時間',

    /**
     * 予約終了時間
     * @name ID022
     * @constant
     * @memberOf const.MessageConst
     */
    ID022: '予約終了時間',

    /**
     * 休み
     * @name ID031
     * @constant
     * @memberOf const.MessageConst
     */
    ID031: '休み',

    /**
     * 利用可
     * @name ID032
     * @constant
     * @memberOf const.MessageConst
     */
    ID032: '利用可',

    /**
     * キャンセル
     * @name ID041
     * @constant
     * @memberOf const.MessageConst
     */
    ID041: 'キャンセル',

    /**
     * 変更
     * @name ID042
     * @constant
     * @memberOf const.MessageConst
     */
    ID042: '変更',

    /**
     * 利用可否
     * @name ID051
     * @constant
     * @memberOf const.MessageConst
     */
    ID051: '利用可否'
  },
  EXCEPTION_DAY_SETTING: {
    /**
     * 例外日設定
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: '例外日設定',

    /**
     * CSVファイルをアップロードすることで、複数の例外日を一括で設定できます。
     * @name ID021
     * @constant
     * @memberOf const.MessageConst
     */
    ID021:
      'CSVファイルをアップロードすることで、複数の例外日を一括で設定できます。',

    /**
     * 現在の例外日情報を出力
     * @name ID031
     * @constant
     * @memberOf const.MessageConst
     */
    ID031: '現在の例外日情報を出力',

    /**
     * バース種別
     * @name ID041
     * @constant
     * @memberOf const.MessageConst
     */
    ID041: 'バース種別',

    /**
     * CSVファイル
     * @name ID051
     * @constant
     * @memberOf const.MessageConst
     */
    ID051: 'CSVファイル',

    /**
     * ファイル選択
     * @name ID052
     * @constant
     * @memberOf const.MessageConst
     */
    ID052: 'ファイル選択',

    /**
     * キャンセル
     * @name ID061
     * @constant
     * @memberOf const.MessageConst
     */
    ID061: 'キャンセル',

    /**
     * 更新
     * @name ID062
     * @constant
     * @memberOf const.MessageConst
     */
    ID062: '更新'
  },
  WORK_TIME_SETTING: {
    /**
     * 作業時間設定
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: '作業時間設定',

    /**
     * 積み方
     * @name ID021
     * @constant
     * @memberOf const.MessageConst
     */
    ID021: '積み方',

    /**
     * ×
     * @name ID031
     * @constant
     * @memberOf const.MessageConst
     */
    ID031: '×',

    /**
     * 車種
     * @name ID032
     * @constant
     * @memberOf const.MessageConst
     */
    ID032: '車種',

    /**
     * 戻る
     * @name ID041
     * @constant
     * @memberOf const.MessageConst
     */
    ID041: '戻る',

    /**
     * 作業時間が設定されていません。
     * @name ID051
     * @constant
     * @memberOf const.MessageConst
     */
    ID051: '作業時間が設定されていません。'
  },
  BERTH_CATEGORY_COMMON: {
    /**
     * 名称
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: '名称',

    /**
     * 予約可能期間
     * @name ID012
     * @constant
     * @memberOf const.MessageConst
     */
    ID012: '予約可能期間',

    /**
     * 日前～
     * @name ID013
     * @constant
     * @memberOf const.MessageConst
     */
    ID013: '日前～',

    /**
     * 日前まで
     * @name ID014
     * @constant
     * @memberOf const.MessageConst
     */
    ID014: '日前まで',

    /**
     * 状態
     * @name ID015
     * @constant
     * @memberOf const.MessageConst
     */
    ID015: '状態',

    /**
     * 有効
     * @name ID016
     * @constant
     * @memberOf const.MessageConst
     */
    ID016: '有効',

    /**
     * 無効
     * @name ID017
     * @constant
     * @memberOf const.MessageConst
     */
    ID017: '無効',

    /**
     * キャンセル
     * @name ID018
     * @constant
     * @memberOf const.MessageConst
     */
    ID018: 'キャンセル',

    /**
     * 日前から
     * @name ID019
     * @constant
     * @memberOf const.MessageConst
     */
    ID019: '日前から',

    /**
     * 開始日
     * @name ID020
     * @constant
     * @memberOf const.MessageConst
     */
    ID020: '開始日',

    /**
     * 終了日
     * @name ID021
     * @constant
     * @memberOf const.MessageConst
     */
    ID021: '終了日'
  },
  BERTH_CATEGORY_LIST: {
    /**
     * バース種別一覧
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: 'バース種別一覧',

    /**
     * 新規登録
     * @name ID021
     * @constant
     * @memberOf const.MessageConst
     */
    ID021: '新規登録',

    /**
     * 削除する
     * @name ID031
     * @constant
     * @memberOf const.MessageConst
     */
    ID031: '削除する',

    /**
     * 変更
     * @name ID041
     * @constant
     * @memberOf const.MessageConst
     */
    ID041: '変更',

    /**
     * 基本情報
     * @name ID051
     * @constant
     * @memberOf const.MessageConst
     */
    ID051: '基本情報',

    /**
     * 利用可能時間
     * @name ID061
     * @constant
     * @memberOf const.MessageConst
     */
    ID061: '利用可能時間',

    /**
     * 開始
     * @name ID062
     * @constant
     * @memberOf const.MessageConst
     */
    ID062: '開始',

    /**
     * 終了
     * @name ID063
     * @constant
     * @memberOf const.MessageConst
     */
    ID063: '終了',

    /**
     * 例外日
     * @name ID066
     * @constant
     * @memberOf const.MessageConst
     */
    ID066: '例外日',

    /**
     * バース一覧
     * @name ID071
     * @constant
     * @memberOf const.MessageConst
     */
    ID071: 'バース一覧',

    /**
     * 一覧
     * @name ID081
     * @constant
     * @memberOf const.MessageConst
     */
    ID081: '一覧'
  },
  BERTH_CATEGORY_REGIST: {
    /**
     * バース基本情報登録
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: 'バース基本情報登録',

    /**
     * 登録
     * @name ID021
     * @constant
     * @memberOf const.MessageConst
     */
    ID021: '登録'
  },
  BERTH_CATEGORY_EDIT: {
    /**
     * バース基本設定編集
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: 'バース基本設定編集',

    /**
     * 変更
     * @name ID021
     * @constant
     * @memberOf const.MessageConst
     */
    ID021: '変更',

    /**
     * バース基本情報
     * @name ID031
     * @constant
     * @memberOf const.MessageConst
     */
    ID031: 'バース基本情報'
  },
  BERTH_COMMON: {
    /**
     * バース名
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: 'バース名',

    /**
     * バース種別
     * @name ID012
     * @constant
     * @memberOf const.MessageConst
     */
    ID012: 'バース種別',

    /**
     * 状態
     * @name ID013
     * @constant
     * @memberOf const.MessageConst
     */
    ID013: '状態',

    /**
     * 有効
     * @name ID014
     * @constant
     * @memberOf const.MessageConst
     */
    ID014: '有効',

    /**
     * 無効
     * @name ID015
     * @constant
     * @memberOf const.MessageConst
     */
    ID015: '無効',

    /**
     * キャンセル
     * @name ID016
     * @constant
     * @memberOf const.MessageConst
     */
    ID016: 'キャンセル',

    /**
     * ふりがな
     * @name ID017
     * @constant
     * @memberOf const.MessageConst
     */
    ID017: 'ふりがな',

    /**
     * 待機場所
     * @name ID018
     * @constant
     * @memberOf const.MessageConst
     */
    ID018: '待機場所'
  },
  BERTH_LIST: {
    /**
     * バース一覧
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: 'バース一覧',

    /**
     * 検索
     * @name ID021
     * @constant
     * @memberOf const.MessageConst
     */
    ID021: '検索',

    /**
     * 新規登録
     * @name ID031
     * @constant
     * @memberOf const.MessageConst
     */
    ID031: '新規登録',

    /**
     * 編集
     * @name ID041
     * @constant
     * @memberOf const.MessageConst
     */
    ID041: '編集',

    /**
     * 選択したバースを削除
     * @name ID051
     * @constant
     * @memberOf const.MessageConst
     */
    ID051: '選択したバースを削除'
  },
  BERTH_REGIST: {
    /**
     * バース登録
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: 'バース登録',

    /**
     * 登録
     * @name ID021
     * @constant
     * @memberOf const.MessageConst
     */
    ID021: '登録'
  },
  BERTH_EDIT: {
    /**
     * バース編集
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: 'バース編集',

    /**
     * 変更
     * @name ID021
     * @constant
     * @memberOf const.MessageConst
     */
    ID021: '変更'
  },
  CAR_MODEL_COMMON: {
    /**
     * 車種名
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: '車種名',

    /**
     * 略称
     * @name ID012
     * @constant
     * @memberOf const.MessageConst
     */
    ID012: '略称',

    /**
     * バース種別
     * @name ID013
     * @constant
     * @memberOf const.MessageConst
     */
    ID013: 'バース種別',

    /**
     * 利用バース数
     * @name ID014
     * @constant
     * @memberOf const.MessageConst
     */
    ID014: '利用バース数',

    /**
     * 状態
     * @name ID016
     * @constant
     * @memberOf const.MessageConst
     */
    ID016: '状態',

    /**
     * 可
     * @name ID017
     * @constant
     * @memberOf const.MessageConst
     */
    ID017: '可',

    /**
     * 不可
     * @name ID018
     * @constant
     * @memberOf const.MessageConst
     */
    ID018: '不可',

    /**
     * 作業時間
     * @name ID019
     * @constant
     * @memberOf const.MessageConst
     */
    ID019: '作業時間'
  },
  CAR_MODEL_LIST: {
    /**
     * 車種一覧
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: '車種一覧',

    /**
     * 検索
     * @name ID021
     * @constant
     * @memberOf const.MessageConst
     */
    ID021: '検索',

    /**
     * 検索結果件数
     * @name ID022
     * @constant
     * @memberOf const.MessageConst
     */
    ID022: '検索結果件数',

    /**
     * 編集
     * @name ID041
     * @constant
     * @memberOf const.MessageConst
     */
    ID041: '編集',

    /**
     * 選択した車種を削除
     * @name ID051
     * @constant
     * @memberOf const.MessageConst
     */
    ID051: '選択した車種を削除'
  },
  CAR_MODEL_EDIT: {
    /**
     * 車種編集
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: '車種編集',

    /**
     * 作業時間
     * @name ID021
     * @constant
     * @memberOf const.MessageConst
     */
    ID021: '作業時間',

    /**
     * キャンセル
     * @name ID031
     * @constant
     * @memberOf const.MessageConst
     */
    ID031: 'キャンセル',

    /**
     * 変更
     * @name ID032
     * @constant
     * @memberOf const.MessageConst
     */
    ID032: '変更'
  },
  CENTER_NOTICE_COMMON: {
    /**
     * 掲載開始日
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: '掲載開始日',

    /**
     * 掲載終了日
     * @name ID012
     * @constant
     * @memberOf const.MessageConst
     */
    ID012: '掲載終了日',

    /**
     * ステータス
     * @name ID013
     * @constant
     * @memberOf const.MessageConst
     */
    ID013: 'ステータス',

    /**
     * タイトル
     * @name ID014
     * @constant
     * @memberOf const.MessageConst
     */
    ID014: 'タイトル',

    /**
     * 内容
     * @name ID015
     * @constant
     * @memberOf const.MessageConst
     */
    ID015: '内容',

    /**
     * キャンセル
     * @name ID016
     * @constant
     * @memberOf const.MessageConst
     */
    ID016: 'キャンセル',

    /**
     * 掲載前
     * @name ID017
     * @constant
     * @memberOf const.MessageConst
     */
    ID017: '掲載前',

    /**
     * 掲載中
     * @name ID018
     * @constant
     * @memberOf const.MessageConst
     */
    ID018: '掲載中',

    /**
     * 掲載終了
     * @name ID019
     * @constant
     * @memberOf const.MessageConst
     */
    ID019: '掲載終了'
  },
  CENTER_NOTICE_LIST: {
    /**
     * お知らせ一覧
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: 'お知らせ一覧',

    /**
     * 開始日
     * @name ID021
     * @constant
     * @memberOf const.MessageConst
     */
    ID021: '開始日',

    /**
     * 終了日
     * @name ID022
     * @constant
     * @memberOf const.MessageConst
     */
    ID022: '終了日',

    /**
     * 検索
     * @name ID023
     * @constant
     * @memberOf const.MessageConst
     */
    ID023: '検索',

    /**
     * 新規登録
     * @name ID031
     * @constant
     * @memberOf const.MessageConst
     */
    ID031: '新規登録',

    /**
     * 掲載期間
     * @name ID041
     * @constant
     * @memberOf const.MessageConst
     */
    ID041: '掲載期間',

    /**
     * 編集
     * @name ID051
     * @constant
     * @memberOf const.MessageConst
     */
    ID051: '編集',

    /**
     * 選択したお知らせを削除
     * @name ID061
     * @constant
     * @memberOf const.MessageConst
     */
    ID061: '選択したお知らせを削除'
  },
  CENTER_NOTICE_REGIST: {
    /**
     * お知らせ登録
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: 'お知らせ登録',

    /**
     * 登録
     * @name ID021
     * @constant
     * @memberOf const.MessageConst
     */
    ID021: '登録'
  },
  CENTER_NOTICE_EDIT: {
    /**
     * お知らせ編集
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: 'お知らせ編集',

    /**
     * 変更
     * @name ID021
     * @constant
     * @memberOf const.MessageConst
     */
    ID021: '変更'
  },
  RECEPTION_LIST: {
    /**
     * 受付一覧
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: '受付一覧',

    /**
     * 対象日
     * @name ID021
     * @constant
     * @memberOf const.MessageConst
     */
    ID021: '対象日',

    /**
     * 開始時間
     * @name ID022
     * @constant
     * @memberOf const.MessageConst
     */
    ID022: '開始時間',

    /**
     * 終了時間
     * @name ID023
     * @constant
     * @memberOf const.MessageConst
     */
    ID023: '終了時間',

    /**
     * バース種別
     * @name ID024
     * @constant
     * @memberOf const.MessageConst
     */
    ID024: 'バース種別',

    /**
     * ステータス
     * @name ID025
     * @constant
     * @memberOf const.MessageConst
     */
    ID025: 'ステータス',

    /**
     * 待機中
     * @name ID031
     * @constant
     * @memberOf const.MessageConst
     */
    ID031: '待機中',

    /**
     * 呼出中
     * @name ID032
     * @constant
     * @memberOf const.MessageConst
     */
    ID032: '呼出中',

    /**
     * 無応答
     * @name ID033
     * @constant
     * @memberOf const.MessageConst
     */
    ID033: '無応答',

    /**
     * 要確認(着信拒否など)
     * @name ID034
     * @constant
     * @memberOf const.MessageConst
     */
    ID034: '要確認(着信拒否など)',

    /**
     * 時間超過
     * @name ID035
     * @constant
     * @memberOf const.MessageConst
     */
    ID035: '時間超過',

    /**
     * 入場待ち
     * @name ID036
     * @constant
     * @memberOf const.MessageConst
     */
    ID036: '入場待ち',

    /**
     * 作業中
     * @name ID037
     * @constant
     * @memberOf const.MessageConst
     */
    ID037: '作業中',

    /**
     * 作業終了
     * @name ID038
     * @constant
     * @memberOf const.MessageConst
     */
    ID038: '作業終了',

    /**
     * キャンセル
     * @name ID039
     * @constant
     * @memberOf const.MessageConst
     */
    ID039: 'キャンセル',

    /**
     * 更新
     * @name ID041
     * @constant
     * @memberOf const.MessageConst
     */
    ID041: '更新',

    /**
     * 検索結果を出力
     * @name ID042
     * @constant
     * @memberOf const.MessageConst
     */
    ID042: '検索結果を出力',

    /**
     * 呼出
     * @name ID051
     * @constant
     * @memberOf const.MessageConst
     */
    ID051: '呼出',

    /**
     * 受付時間
     * @name ID052
     * @constant
     * @memberOf const.MessageConst
     */
    ID052: '受付時間',

    /**
     * 事前予約有無
     * @name ID053
     * @constant
     * @memberOf const.MessageConst
     */
    ID053: '事前予約有無',

    /**
     * 積み方
     * @name ID054
     * @constant
     * @memberOf const.MessageConst
     */
    ID054: '積み方',

    /**
     * 車種
     * @name ID055
     * @constant
     * @memberOf const.MessageConst
     */
    ID055: '車種',

    /**
     * 車両番号
     * @name ID056
     * @constant
     * @memberOf const.MessageConst
     */
    ID056: '車両番号',

    /**
     * 仕入先/出荷先名
     * @name ID057
     * @constant
     * @memberOf const.MessageConst
     */
    ID057: '仕入先/出荷先名',

    /**
     * 運送会社名
     * @name ID058
     * @constant
     * @memberOf const.MessageConst
     */
    ID058: '運送会社名',

    /**
     * 添付
     * @name ID059
     * @constant
     * @memberOf const.MessageConst
     */
    ID059: '添付',

    /**
     * 自動受付
     * @name ID060
     * @constant
     * @memberOf const.MessageConst
     */
    ID060: '自動受付',

    /**
     * 詳細
     * @name ID061
     * @constant
     * @memberOf const.MessageConst
     */
    ID061: '詳細',

    /**
     * なし
     * @name ID062
     * @constant
     * @memberOf const.MessageConst
     */
    ID062: 'なし',

    /**
     * 編集
     * @name ID063
     * @constant
     * @memberOf const.MessageConst
     */
    ID063: '編集',

    /**
     * 作業情報
     * @name ID071
     * @constant
     * @memberOf const.MessageConst
     */
    ID071: '作業情報',

    /**
     * ドライバー名
     * @name ID081
     * @constant
     * @memberOf const.MessageConst
     */
    ID081: 'ドライバー名',

    /**
     * ドライバー電話番号
     * @name ID082
     * @constant
     * @memberOf const.MessageConst
     */
    ID082: 'ドライバー電話番号',

    /**
     * ドライバーメールアドレス
     * @name ID083
     * @constant
     * @memberOf const.MessageConst
     */
    ID083: 'ドライバーメールアドレス',

    /**
     * 備考
     * @name ID084
     * @constant
     * @memberOf const.MessageConst
     */
    ID084: '備考',

    /**
     * 添付ファイル
     * @name ID085
     * @constant
     * @memberOf const.MessageConst
     */
    ID085: '添付ファイル',

    /**
     * 一括ダウンロード
     * @name ID091
     * @constant
     * @memberOf const.MessageConst
     */
    ID091: '一括ダウンロード',

    /**
     * 削除
     * @name ID092
     * @constant
     * @memberOf const.MessageConst
     */
    ID092: '削除',

    /**
     * この受付をキャンセルする
     * @name ID093
     * @constant
     * @memberOf const.MessageConst
     */
    ID093: 'この受付をキャンセルする',

    /**
     * この受付をキャンセルしますか？
     * @name ID094
     * @constant
     * @memberOf const.MessageConst
     */
    ID094: 'この受付をキャンセルしますか？',

    /**
     * 呼び出すバース番号を選択してください。
     * @name ID101
     * @constant
     * @memberOf const.MessageConst
     */
    ID101: '呼び出すバース番号を選択してください。',

    /**
     * 作業種別
     * @name ID102
     * @constant
     * @memberOf const.MessageConst
     */
    ID102: '作業種別',

    /**
     * 呼出
     * @name ID103
     * @constant
     * @memberOf const.MessageConst
     */
    ID103: '呼出',

    /**
     * 呼出中
     * @name ID104
     * @constant
     * @memberOf const.MessageConst
     */
    ID104: '呼出中',

    /**
     * 呼出に成功しました。
     * @name ID105
     * @constant
     * @memberOf const.MessageConst
     */
    ID105: '呼出に成功しました。',

    /**
     * OK
     * @name ID106
     * @constant
     * @memberOf const.MessageConst
     */
    ID106: 'OK',

    /**
     * 呼出に失敗しました。
     * @name ID107
     * @constant
     * @memberOf const.MessageConst
     */
    ID107: '呼出に失敗しました。',

    /**
     * 応答がありません。
     * @name ID108
     * @constant
     * @memberOf const.MessageConst
     */
    ID108: '応答がありません。',

    /**
     * 他の作業員が呼出中です。
     * @name ID109
     * @constant
     * @memberOf const.MessageConst
     */
    ID109: '他の作業員が呼出中です。',

    /**
     * 到着予測時間<br>
     * DoCoMap連携
     * @name ID110
     * @constant
     * @memberOf const.MessageConst
     */
    ID110: '到着予測時間',

    /**
     * 測定値<br>
     * 検温オプション
     * @name ID121
     * @constant
     * @memberOf const.MessageConst
     */
    ID121: '測定値',

    /**
     * アンケート<br>
     * 検温オプション
     * @name ID122
     * @constant
     * @memberOf const.MessageConst
     */
    ID122: 'アンケート',

    /**
     * SMS送信中<br>
     * 日本トランスシティカスタマイズ
     * @name ID123
     * @constant
     * @memberOf const.MessageConst
     */
    ID123: 'SMS送信中',

    /**
     * SMS送信に成功しました。<br>
     * 日本トランスシティカスタマイズ
     * @name ID124
     * @constant
     * @memberOf const.MessageConst
     */
    ID124: 'SMS送信に成功しました。',

    /**
     * SMS送信に失敗しました。<br>
     * 日本トランスシティカスタマイズ
     * @name ID125
     * @constant
     * @memberOf const.MessageConst
     */
    ID125: 'SMS送信に失敗しました。',

    /**
     * 送信<br>
     * 日本トランスシティカスタマイズ
     * @name ID126
     * @constant
     * @memberOf const.MessageConst
     */
    ID126: '送信'
  },
  RECEPTION_EDIT: {
    /**
     * 受付編集
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: '受付編集',

    /**
     * --.-<br>
     * 検温オプション
     * @name ID021
     * @constant
     * @memberOf const.MessageConst
     */
    ID021: '--.-',

    /**
     * 予約添付ファイル<br>
     * 検温オプション
     * @name ID022
     * @constant
     * @memberOf const.MessageConst
     */
    ID022: '予約添付ファイル',

    /**
     * 受付添付ファイル<br>
     * 検温オプション
     * @name ID023
     * @constant
     * @memberOf const.MessageConst
     */
    ID023: '受付添付ファイル'
  },
  WORK_RESULT_INPUT: {
    /**
     * 作業結果入力
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: '作業結果入力',

    /**
     * 作業開始
     * @name ID021
     * @constant
     * @memberOf const.MessageConst
     */
    ID021: '作業開始',

    /**
     * 作業終了
     * @name ID022
     * @constant
     * @memberOf const.MessageConst
     */
    ID022: '作業終了',

    /**
     * 開始
     * @name ID031
     * @constant
     * @memberOf const.MessageConst
     */
    ID031: '開始',

    /**
     * 戻る
     * @name ID041
     * @constant
     * @memberOf const.MessageConst
     */
    ID041: '戻る'
  },
  SIGN_DRAWING: {
    /**
     * サイン入力
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: 'サイン入力',

    /**
     * 確定
     * @name ID021
     * @constant
     * @memberOf const.MessageConst
     */
    ID021: '確定',

    /**
     * クリア
     * @name ID022
     * @constant
     * @memberOf const.MessageConst
     */
    ID022: 'クリア',

    /**
     * 戻る
     * @name ID023
     * @constant
     * @memberOf const.MessageConst
     */
    ID023: '戻る',

    /**
     * このブラウザでは表示できません
     * @name ID031
     * @constant
     * @memberOf const.MessageConst
     */
    ID031: 'このブラウザでは表示できません'
  },
  CONGESTION_SITUATION_LIST: {
    /**
     * 混雑状況一覧
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: '混雑状況一覧',

    /**
     * 更新
     * @name ID021
     * @constant
     * @memberOf const.MessageConst
     */
    ID021: '更新',

    /**
     * 最終更新時刻：
     * @name ID022
     * @constant
     * @memberOf const.MessageConst
     */
    ID022: '最終更新時刻：',

    /**
     * 台待ち
     * @name ID031
     * @constant
     * @memberOf const.MessageConst
     */
    ID031: '台待ち',

    /**
     * 呼出番号
     * @name ID041
     * @constant
     * @memberOf const.MessageConst
     */
    ID041: '呼出番号',

    /**
     * お待ちの番号
     * @name ID042
     * @constant
     * @memberOf const.MessageConst
     */
    ID042: 'お待ちの番号',

    /**
     * 呼出ダイヤID
     * @name ID043
     * @constant
     * @memberOf const.MessageConst
     */
    ID043: '呼出ダイヤID',

    /**
     * お待ちのダイヤID
     * @name ID044
     * @constant
     * @memberOf const.MessageConst
     */
    ID044: 'お待ちのダイヤID'
  },
  FULL_EMPTY_LIST: {
    /**
     * 満空情報
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: '満空情報',

    /**
     * 更新
     * @name ID021
     * @constant
     * @memberOf const.MessageConst
     */
    ID021: '更新',

    /**
     * 最終更新時刻：
     * @name ID022
     * @constant
     * @memberOf const.MessageConst
     */
    ID022: '最終更新時刻：',

    /**
     * バース
     * @name ID031
     * @constant
     * @memberOf const.MessageConst
     */
    ID031: 'バース',

    /**
     * 待機場
     * @name ID032
     * @constant
     * @memberOf const.MessageConst
     */
    ID032: '待機場',

    /**
     * 満
     * @name ID041
     * @constant
     * @memberOf const.MessageConst
     */
    ID041: '満',

    /**
     * 空
     * @name ID042
     * @constant
     * @memberOf const.MessageConst
     */
    ID042: '空'
  },
  ACHIEVEMENT_LIST: {
    /**
     * 実績一覧
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: '実績一覧',

    /**
     * 開始時間
     * @name ID021
     * @constant
     * @memberOf const.MessageConst
     */
    ID021: '開始時間',

    /**
     * 終了時間
     * @name ID022
     * @constant
     * @memberOf const.MessageConst
     */
    ID022: '終了時間',

    /**
     * バース種別
     * @name ID023
     * @constant
     * @memberOf const.MessageConst
     */
    ID023: 'バース種別',

    /**
     * 作業結果
     * @name ID024
     * @constant
     * @memberOf const.MessageConst
     */
    ID024: '作業結果',

    /**
     * 仕入先/出荷先名
     * @name ID025
     * @constant
     * @memberOf const.MessageConst
     */
    ID025: '仕入先/出荷先名',

    /**
     * 運送会社名
     * @name ID026
     * @constant
     * @memberOf const.MessageConst
     */
    ID026: '運送会社名',

    /**
     * 備考
     * @name ID027
     * @constant
     * @memberOf const.MessageConst
     */
    ID027: '備考',

    /**
     * 更新
     * @name ID031
     * @constant
     * @memberOf const.MessageConst
     */
    ID031: '更新',

    /**
     * 検索結果を出力
     * @name ID032
     * @constant
     * @memberOf const.MessageConst
     */
    ID032: '検索結果を出力',

    /**
     * 日時
     * @name ID041
     * @constant
     * @memberOf const.MessageConst
     */
    ID041: '日時',

    /**
     * 予約時間
     * @name ID042
     * @constant
     * @memberOf const.MessageConst
     */
    ID042: '予約時間',

    /**
     * 受付時間
     * @name ID043
     * @constant
     * @memberOf const.MessageConst
     */
    ID043: '受付時間',

    /**
     * 呼出時間
     * @name ID044
     * @constant
     * @memberOf const.MessageConst
     */
    ID044: '呼出時間',

    /**
     * 作業開始時間
     * @name ID045
     * @constant
     * @memberOf const.MessageConst
     */
    ID045: '作業開始時間',

    /**
     * 作業終了時間
     * @name ID046
     * @constant
     * @memberOf const.MessageConst
     */
    ID046: '作業終了時間',

    /**
     * 添付
     * @name ID047
     * @constant
     * @memberOf const.MessageConst
     */
    ID047: '添付',

    /**
     * 添付ファイル
     * @name ID048
     * @constant
     * @memberOf const.MessageConst
     */
    ID048: '添付ファイル',

    /**
     * 一括ダウンロード
     * @name ID049
     * @constant
     * @memberOf const.MessageConst
     */
    ID049: '一括ダウンロード',

    /**
     * 詳細
     * @name ID051
     * @constant
     * @memberOf const.MessageConst
     */
    ID051: '詳細',

    /**
     * サイン確認
     * @name ID052
     * @constant
     * @memberOf const.MessageConst
     */
    ID052: 'サイン確認',

    /**
     * 自動受付
     * @name ID053
     * @constant
     * @memberOf const.MessageConst
     */
    ID053: '自動受付',

    /**
     * 編集
     * @name ID054
     * @constant
     * @memberOf const.MessageConst
     */
    ID054: '編集',

    /**
     * バース
     * @name ID055
     * @constant
     * @memberOf const.MessageConst
     */
    ID055: 'バース',

    /**
     * 滞在時間
     * @name ID056
     * @constant
     * @memberOf const.MessageConst
     */
    ID056: '滞在時間',

    /**
     * 作業情報
     * @name ID060
     * @constant
     * @memberOf const.MessageConst
     */
    ID060: '作業情報',

    /**
     * 各作業の開始終了時間
     * @name ID061
     * @constant
     * @memberOf const.MessageConst
     */
    ID061: '各作業の開始終了時間',

    /**
     * 作業項目
     * @name ID070
     * @constant
     * @memberOf const.MessageConst
     */
    ID070: '作業項目',

    /**
     * 開始時間
     * @name ID071
     * @constant
     * @memberOf const.MessageConst
     */
    ID071: '開始時間',

    /**
     * 終了時間
     * @name ID072
     * @constant
     * @memberOf const.MessageConst
     */
    ID072: '終了時間',

    /**
     * 作業時間(分)
     * @name ID073
     * @constant
     * @memberOf const.MessageConst
     */
    ID073: '作業時間(分)'
  },
  ACHIEVEMENT_EDIT: {
    /**
     * 実績編集
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: '実績編集',

    /**
     * 実績ID
     * @name ID021
     * @constant
     * @memberOf const.MessageConst
     */
    ID021: '実績ID',

    /**
     * 日時
     * @name ID022
     * @constant
     * @memberOf const.MessageConst
     */
    ID022: '日時',

    /**
     * 運送会社名
     * @name ID023
     * @constant
     * @memberOf const.MessageConst
     */
    ID023: '運送会社名',

    /**
     * 仕入先/出荷先名
     * @name ID024
     * @constant
     * @memberOf const.MessageConst
     */
    ID024: '仕入先/出荷先名',

    /**
     * バース種別
     * @name ID025
     * @constant
     * @memberOf const.MessageConst
     */
    ID025: 'バース種別',

    /**
     * バース名
     * @name ID026
     * @constant
     * @memberOf const.MessageConst
     */
    ID026: 'バース名',

    /**
     * 作業結果
     * @name ID027
     * @constant
     * @memberOf const.MessageConst
     */
    ID027: '作業結果',

    /**
     * 作業開始日時
     * @name ID028
     * @constant
     * @memberOf const.MessageConst
     */
    ID028: '作業開始日時',

    /**
     * 作業終了日時
     * @name ID029
     * @constant
     * @memberOf const.MessageConst
     */
    ID029: '作業終了日時',

    /**
     * 滞在時間
     * @name ID030
     * @constant
     * @memberOf const.MessageConst
     */
    ID030: '滞在時間',

    /**
     * 備考
     * @name ID031
     * @constant
     * @memberOf const.MessageConst
     */
    ID031: '備考',

    /**
     * 添付ファイル
     * @name ID032
     * @constant
     * @memberOf const.MessageConst
     */
    ID032: '添付ファイル',

    /**
     * ダウンロード
     * @name ID033
     * @constant
     * @memberOf const.MessageConst
     */
    ID033: 'ダウンロード',

    /**
     * 変更
     * @name ID051
     * @constant
     * @memberOf const.MessageConst
     */
    ID051: '変更'
  },
  BOOKING_RECEPTION_LIST: {
    /**
     * 予約・受付一覧
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: '予約・受付一覧',

    /**
     * 開始日時
     * @name ID021
     * @constant
     * @memberOf const.MessageConst
     */
    ID021: '開始日時',

    /**
     * 終了日時
     * @name ID022
     * @constant
     * @memberOf const.MessageConst
     */
    ID022: '終了日時',

    /**
     * ステータス
     * @name ID023
     * @constant
     * @memberOf const.MessageConst
     */
    ID023: 'ステータス',

    /**
     * バース種別
     * @name ID024
     * @constant
     * @memberOf const.MessageConst
     */
    ID024: 'バース種別',

    /**
     * 割当バース
     * @name ID025
     * @constant
     * @memberOf const.MessageConst
     */
    ID025: '割当バース',

    /**
     * 作業バース
     * @name ID026
     * @constant
     * @memberOf const.MessageConst
     */
    ID026: '作業バース',

    /**
     * 検索
     * @name ID031
     * @constant
     * @memberOf const.MessageConst
     */
    ID031: '検索',

    /**
     * 検索結果を出力
     * @name ID032
     * @constant
     * @memberOf const.MessageConst
     */
    ID032: '検索結果を出力',

    /**
     * 呼出
     * @name ID041
     * @constant
     * @memberOf const.MessageConst
     */
    ID041: '呼出',

    /**
     * 予約日時
     * @name ID042
     * @constant
     * @memberOf const.MessageConst
     */
    ID042: '予約日時',

    /**
     * ダイヤID
     * @name ID043
     * @constant
     * @memberOf const.MessageConst
     */
    ID043: 'ダイヤID',

    /**
     * 受付時間
     * @name ID044
     * @constant
     * @memberOf const.MessageConst
     */
    ID044: '受付時間',

    /**
     * ステータス
     * @name ID045
     * @constant
     * @memberOf const.MessageConst
     */
    ID045: 'ステータス',

    /**
     * バース種別
     * @name ID046
     * @constant
     * @memberOf const.MessageConst
     */
    ID046: 'バース種別',

    /**
     * 割当バース
     * @name ID047
     * @constant
     * @memberOf const.MessageConst
     */
    ID047: '割当バース',

    /**
     * 作業バース
     * @name ID048
     * @constant
     * @memberOf const.MessageConst
     */
    ID048: '作業バース',

    /**
     * 運送会社名
     * @name ID049
     * @constant
     * @memberOf const.MessageConst
     */
    ID049: '運送会社名',

    /**
     * 車両番号
     * @name ID050
     * @constant
     * @memberOf const.MessageConst
     */
    ID050: '車両番号',

    /**
     * 呼出時間
     * @name ID051
     * @constant
     * @memberOf const.MessageConst
     */
    ID051: '呼出時間',

    /**
     * 作業開始時間
     * @name ID052
     * @constant
     * @memberOf const.MessageConst
     */
    ID052: '作業開始時間',

    /**
     * 作業終了時間
     * @name ID053
     * @constant
     * @memberOf const.MessageConst
     */
    ID053: '作業終了時間',

    /**
     * 添付
     * @name ID054
     * @constant
     * @memberOf const.MessageConst
     */
    ID054: '添付',

    /**
     * 詳細
     * @name ID071
     * @constant
     * @memberOf const.MessageConst
     */
    ID071: '詳細',

    /**
     * 編集
     * @name ID072
     * @constant
     * @memberOf const.MessageConst
     */
    ID072: '編集',

    /**
     * 選択した予約を削除
     * @name ID081
     * @constant
     * @memberOf const.MessageConst
     */
    ID081: '選択した予約を削除',

    /**
     * 作業結果
     * @name ID082
     * @constant
     * @memberOf const.MessageConst
     */
    ID082: '作業結果',

    /**
     * 正常
     * @name ID083
     * @constant
     * @memberOf const.MessageConst
     */
    ID083: '正常',

    /**
     * 異常
     * @name ID084
     * @constant
     * @memberOf const.MessageConst
     */
    ID084: '異常',

    /**
     * 仕入先/出荷先名
     * @name ID085
     * @constant
     * @memberOf const.MessageConst
     */
    ID085: '仕入先/出荷先名'
  },
  BOOKING_RECEPTION_EDIT: {
    /**
     * 予約・受付編集
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: '予約・受付編集',

    /**
     * 予約ID
     * @name ID021
     * @constant
     * @memberOf const.MessageConst
     */
    ID021: '予約ID',

    /**
     * 予定開始日時
     * @name ID022
     * @constant
     * @memberOf const.MessageConst
     */
    ID022: '予定開始日時',

    /**
     * 予定終了日時
     * @name ID023
     * @constant
     * @memberOf const.MessageConst
     */
    ID023: '予定終了日時',

    /**
     * ダイヤID
     * @name ID024
     * @constant
     * @memberOf const.MessageConst
     */
    ID024: 'ダイヤID',

    /**
     * ステータス
     * @name ID025
     * @constant
     * @memberOf const.MessageConst
     */
    ID025: 'ステータス',

    /**
     * バース種別
     * @name ID026
     * @constant
     * @memberOf const.MessageConst
     */
    ID026: 'バース種別',

    /**
     * 割当バース
     * @name ID027
     * @constant
     * @memberOf const.MessageConst
     */
    ID027: '割当バース',

    /**
     * 作業バース
     * @name ID028
     * @constant
     * @memberOf const.MessageConst
     */
    ID028: '作業バース',

    /**
     * 配送会社名
     * @name ID029
     * @constant
     * @memberOf const.MessageConst
     */
    ID029: '配送会社名',

    /**
     * 運送会社名
     * @name ID030
     * @constant
     * @memberOf const.MessageConst
     */
    ID030: '運送会社名',

    /**
     * 仕入先/出荷先名
     * @name ID031
     * @constant
     * @memberOf const.MessageConst
     */
    ID031: '仕入先/出荷先名',

    /**
     * 記号グループ
     * @name ID032
     * @constant
     * @memberOf const.MessageConst
     */
    ID032: '記号グループ',

    /**
     * 車種
     * @name ID033
     * @constant
     * @memberOf const.MessageConst
     */
    ID033: '車種',

    /**
     * 車両番号
     * @name ID034
     * @constant
     * @memberOf const.MessageConst
     */
    ID034: '車両番号',

    /**
     * ドライバー名
     * @name ID035
     * @constant
     * @memberOf const.MessageConst
     */
    ID035: 'ドライバー名',

    /**
     * ドライバー電話番号
     * @name ID036
     * @constant
     * @memberOf const.MessageConst
     */
    ID036: 'ドライバー電話番号',

    /**
     * パレット枚数
     * @name ID037
     * @constant
     * @memberOf const.MessageConst
     */
    ID037: 'パレット枚数',

    /**
     * 備考
     * @name ID038
     * @constant
     * @memberOf const.MessageConst
     */
    ID038: '備考',

    /**
     * 受付日時
     * @name ID039
     * @constant
     * @memberOf const.MessageConst
     */
    ID039: '受付日時',

    /**
     * 呼出日時
     * @name ID040
     * @constant
     * @memberOf const.MessageConst
     */
    ID040: '呼出日時',

    /**
     * 作業開始日時
     * @name ID041
     * @constant
     * @memberOf const.MessageConst
     */
    ID041: '作業開始日時',

    /**
     * 作業終了日時
     * @name ID042
     * @constant
     * @memberOf const.MessageConst
     */
    ID042: '作業終了日時',

    /**
     * キャンセル
     * @name ID051
     * @constant
     * @memberOf const.MessageConst
     */
    ID051: 'キャンセル',

    /**
     * 変更
     * @name ID052
     * @constant
     * @memberOf const.MessageConst
     */
    ID052: '変更',

    /**
     * 添付ファイル
     * @name ID053
     * @constant
     * @memberOf const.MessageConst
     */
    ID053: '添付ファイル',

    /**
     * コンテナ
     * @name ID054
     * @constant
     * @memberOf const.MessageConst
     */
    ID054: 'コンテナ'
  },
  BOOKING_RECEPTION_WIDGET: {
    /**
     * 予約・受付詳細
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: '予約・受付詳細',

    /**
     * 予約ID
     * @name ID021
     * @constant
     * @memberOf const.MessageConst
     */
    ID021: '予約ID',

    /**
     * 予約日時
     * @name ID022
     * @constant
     * @memberOf const.MessageConst
     */
    ID022: '予約日時',

    /**
     * 予定終了日時
     * @name ID023
     * @constant
     * @memberOf const.MessageConst
     */
    ID023: '予定終了日時',

    /**
     * ダイヤID
     * @name ID024
     * @constant
     * @memberOf const.MessageConst
     */
    ID024: 'ダイヤID',

    /**
     * ステータス
     * @name ID025
     * @constant
     * @memberOf const.MessageConst
     */
    ID025: 'ステータス',

    /**
     * バース種別
     * @name ID026
     * @constant
     * @memberOf const.MessageConst
     */
    ID026: 'バース種別',

    /**
     * 割当バース
     * @name ID027
     * @constant
     * @memberOf const.MessageConst
     */
    ID027: '割当バース',

    /**
     * 作業バース
     * @name ID028
     * @constant
     * @memberOf const.MessageConst
     */
    ID028: '作業バース',

    /**
     * 配送会社名
     * @name ID029
     * @constant
     * @memberOf const.MessageConst
     */
    ID029: '配送会社名',

    /**
     * 運送会社名
     * @name ID030
     * @constant
     * @memberOf const.MessageConst
     */
    ID030: '運送会社名',

    /**
     * 仕入先/出荷先名
     * @name ID031
     * @constant
     * @memberOf const.MessageConst
     */
    ID031: '仕入先/出荷先名',

    /**
     * 記号グループ
     * @name ID032
     * @constant
     * @memberOf const.MessageConst
     */
    ID032: '記号グループ',

    /**
     * 車種
     * @name ID033
     * @constant
     * @memberOf const.MessageConst
     */
    ID033: '車種',

    /**
     * 車両番号
     * @name ID034
     * @constant
     * @memberOf const.MessageConst
     */
    ID034: '車両番号',

    /**
     * ドライバー名
     * @name ID035
     * @constant
     * @memberOf const.MessageConst
     */
    ID035: 'ドライバー名',

    /**
     * ドライバー電話番号
     * @name ID036
     * @constant
     * @memberOf const.MessageConst
     */
    ID036: 'ドライバー電話番号',

    /**
     * パレット枚数
     * @name ID037
     * @constant
     * @memberOf const.MessageConst
     */
    ID037: 'パレット枚数',

    /**
     * 備考
     * @name ID038
     * @constant
     * @memberOf const.MessageConst
     */
    ID038: '備考',

    /**
     * 受付時間
     * @name ID039
     * @constant
     * @memberOf const.MessageConst
     */
    ID039: '受付時間',

    /**
     * 呼出時間
     * @name ID040
     * @constant
     * @memberOf const.MessageConst
     */
    ID040: '呼出時間',

    /**
     * 作業開始時間
     * @name ID041
     * @constant
     * @memberOf const.MessageConst
     */
    ID041: '作業開始時間',

    /**
     * 作業終了時間
     * @name ID042
     * @constant
     * @memberOf const.MessageConst
     */
    ID042: '作業終了時間',

    /**
     * 削除
     * @name ID051
     * @constant
     * @memberOf const.MessageConst
     */
    ID051: '削除',

    /**
     * 編集
     * @name ID052
     * @constant
     * @memberOf const.MessageConst
     */
    ID052: '編集',

    /**
     * この予約を未割当
     * @name ID053
     * @constant
     * @memberOf const.MessageConst
     */
    ID053: 'この予約を未割当',

    /**
     * この予約だけ確定
     * @name ID054
     * @constant
     * @memberOf const.MessageConst
     */
    ID054: 'この予約だけ確定',

    /**
     * この受付をキャンセルする
     * @name ID055
     * @constant
     * @memberOf const.MessageConst
     */
    ID055: 'この受付をキャンセルする',

    /**
     * 種別
     * @name ID056
     * @constant
     * @memberOf const.MessageConst
     */
    ID056: '種別',

    /**
     * 事前予約
     * @name ID057
     * @constant
     * @memberOf const.MessageConst
     */
    ID057: '事前予約',

    /**
     * 臨時便
     * @name ID058
     * @constant
     * @memberOf const.MessageConst
     */
    ID058: '臨時便'
  },
  MASTER_SETTING: {
    /**
     * マスタデータの登録
     * @name ID011
     * @constant
     * @memberOf const.MessageConst
     */
    ID011: 'マスタデータの登録',

    /**
     * 取り込むデータを選択してください。
     * @name ID021
     * @constant
     * @memberOf const.MessageConst
     */
    ID021: '取り込むデータを選択してください。',

    /**
     * 登録済みデータをCSVファイルでダウンロード。
     * @name ID022
     * @constant
     * @memberOf const.MessageConst
     */
    ID022: '登録済みデータをCSVファイルでダウンロード。',

    /**
     * キャンセル
     * @name ID023
     * @constant
     * @memberOf const.MessageConst
     */
    ID023: 'キャンセル',

    /**
     * 登録
     * @name ID024
     * @constant
     * @memberOf const.MessageConst
     */
    ID024: '登録',

    /**
     * 記号グループマスタ
     * @name ID025
     * @constant
     * @memberOf const.MessageConst
     */
    ID025: '記号グループマスタ',

    /**
     * 仕入先/出荷先マスタ
     * @name ID026
     * @constant
     * @memberOf const.MessageConst
     */
    ID026: '仕入先/出荷先マスタ',

    /**
     * バース割当マスタ
     * @name ID027
     * @constant
     * @memberOf const.MessageConst
     */
    ID027: 'バース割当マスタ',

    /**
     * アラート通知先マスタ
     * @name ID028
     * @constant
     * @memberOf const.MessageConst
     */
    ID028: 'アラート通知先マスタ'
  }
};

export default MessageConst;



// WEBPACK FOOTER //
// ./src/js/const/MessageConst.jsx